import { ChangeDetectorRef, Component, EventEmitter, Inject, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { NewContractPymesService } from '../../../services/new-contract-pymes.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Campaign, CampaignLevel, AnalysisSavedData, GenericResponse, CupsPTData } from '@interfaces';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CupsDialogComponent } from './cups-dialog/cups-dialog.component';
import { DeleteDialogComponent } from './delete-dialog/delete-dialog.component';
import { ToastrService } from 'src/app/shared/ui/toastr/toastr.service';
import { UtilService } from 'src/app/services/util.service';
import { CampaignsService } from '../../campaigns/services/campaigns.service';
import { I18NEXT_SERVICE } from 'angular-i18next';
import { Select } from '@interfaces';
import { AuthService } from 'src/app/auth';
import { Tensions, Tension, Cycle, Period } from '../new-contract-pymes.model';
import { HttpErrorResponse } from '@angular/common/http';
import { UtilValidatorsService } from 'src/app/commons/validations-format/util-validators.service';
import { CampaignDetail, Fee } from '../../campaigns/models/campaign.models';
import { EnterMargins } from '../../renovate-contract-pymes/models/renovate-contract-pymes.model';
import { validateIBANPortugal } from 'src/app/commons/utils';

@Component({
  selector: 'app-risk-analysis-pymes',
  templateUrl: './risk-analysis-pymes.component.html',
  styleUrls: [ './risk-analysis-pymes.component.scss' ],
  encapsulation: ViewEncapsulation.None
})
export class RiskAnalysisPymesComponent implements OnInit, OnDestroy {
  private destroyed$: Subject<boolean> = new Subject<boolean>();
  public riskAnalysisForm: FormGroup;
  public queryApproved = new BehaviorSubject(false);
  public showApproved = false;
  public campaignsList: Campaign[] = [];
  private campaignsListRes: Campaign[] = [];
  public campaignLevels: CampaignLevel[] = [];
  private campaignLevelsList: CampaignLevel[] = [];
  public feeList = [
    { value: '2.0TD', label: '2.0TD' },
    { value: '3.0TD', label: '3.0TD' },
    { value: '6.1TD', label: '6.1TD' },
    { value: '6.2TD', label: '6.2TD' },
    { value: '6.3TD', label: '6.3TD' },
    { value: '6.4TD', label: '6.4TD' }
  ];
  public defaultValueCampaign: string;
  public defaultValueLevel: number;
  private consumoEstimado = 0;
  public enableQueryButton: boolean;
  private cupsValid = false;
  private cupsCalled: string = null;
  public draftLoaded = false;
  public campaignsSelectDisabled = true;
  public levelsSelectDisabled = true;
  public geographicZone = '';
  public today = new Date();
  public showCalculation = false;
  public resultCalculation = true;
  public campaignBase: boolean;
  public resultTP = [];
  public resultTE = [];
  private resultNegative = false;
  public unitsTE: Select[] = [
    { value: '0', label: '€ / kWh' },
    { value: '100', label: 'ctms / kWh' },
    { value: '1000', label: '€ / MWh' }
  ];
  public unitsTP: Select[] = [];
  public valueUnitsTE = '0';
  public valueUnitsTP = '0';
  public regexTwoWholeTwoDecimal = new RegExp(/^(\d{1,2}(\,\d{0,3})?|\.?\d{1,2})$/g);
  public regexTwoDecimal = new RegExp(/^(\d+(\,\d{0,2})?)$/g);
  public regexThreeDecimal = new RegExp(/^(\d+(\,\d{0,3})?)$/g);
  public regexSixDecimal = new RegExp(/^(\d+(\,\d{0,6})?|\,?\d{1,3})$/g);
  private patternTwoDecimal = '([0-9]*(,[0-9]{1,2})?)';
  private patternThreeDecimal = '([0-9]*(,[0-9]{1,3})?)';
  public estimatedConsumption = [];
  public contractPotency = [];
  public campaignTE = [];
  public camaignRealTE = [];
  private campaignTP = [];
  private commissionTE: number;
  private commissionTP: number;
  public tarifaSipsReal = '';
  public feeAux = '';
  public campaignAI = [];
  public campaignKI = [];
  public fixPrice: boolean;
  public resultAI = [];
  public canSettlements: boolean;
  public isUserSpanish = true;
  public tensionCyclePeriod: Tensions;
  public tensionList: Select[] = [];
  public cycleList: Select[] = [];
  private tensionSelected: Tension;
  private cycleSelected: Cycle;
  public periodList: Select[] = [];
  public periodSelected: Period;
  public potencyList: Select[] = [];
  public minPotency: string;
  private isPotencyDisabled = false;
  public passThrough: boolean;
  public fijoFlex: boolean;
  public selectedCampaignFee: Fee;
  private repin: boolean = false;
  public greaterEqual100: boolean;
  public campaignFI = [];
  public campaignCG = [];
  public campaignGDOS = [];
  public campaignPFijo = [];
  public selectedCampaign: Campaign;
  public campaignDetail: CampaignDetail[];
  public enterMarginsDraft: EnterMargins;
  public showBankAccountFields = false;
  private enterMarginsValid = false;

  @Output() formValid: EventEmitter<any> = new EventEmitter();
  @Output() draftEnable: EventEmitter<boolean> = new EventEmitter();
  @Output() isLoading: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder,
    private newContractPymesService: NewContractPymesService,
    private dialog: MatDialog,
    private dialogDelete: MatDialog,
    private toastrService: ToastrService,
    private cdRef: ChangeDetectorRef,
    private utilService: UtilService,
    private campaignsService: CampaignsService,
    private authService: AuthService,
    private utilValidatorsService: UtilValidatorsService,
    @Inject(I18NEXT_SERVICE) private i18NextService
  ) {
    this.today.setDate(this.today.getDate() + 1);
  }

  ngOnInit(): void {
    this.canSettlements = this.authService.getUserData().hasAccessToSettlement;
    this.isUserSpanish = this.authService.getUserData().country === 'ES';
    this.subscribeLanguajeChanges();
    this.riskAnalysisForm = this.formBuilder.group({
      cups: [ '', [ this.utilValidatorsService.validateCUPS, Validators.required, Validators.maxLength(22) ] ],
      cif: [ { value: '', disabled: true }, [ this.utilValidatorsService.validateCIFNIF, Validators.required, Validators.maxLength(9) ] ],
      consumption: [ { value: '', disabled: true } ],
      tension: [ { value: null, disabled: true } ],
      cycle: [ { value: null, disabled: true } ],
      period: [ { value: null, disabled: true } ],
      potency: [ { value: null, disabled: true } ],
      customPotency: [ { value: '', disabled: true } ],
      radioDate: [ { value: '1', disabled: true } ],
      invoiceDate: [ null ],
      fee: [ { value: null, disabled: true }, Validators.required ],
      campaign: [ { value: '', disabled: true }, Validators.required ],
      level: [ { value: '', disabled: true }, Validators.required ],
      calculateCommission: [ { value: '1', disabled: true } ],
      unitsTE: null,
      unitsTP: null,
      enterMargins: this.enterMargins(),
      calculateMargins: this.calculateMargins(),
      commission: null,
      payment: [ { value: '0', disabled: true }, this.isUserSpanish ? null : Validators.required ],
      iban: [ { value: ' ', disabled: true } ],
      entity: [ { value: ' ', disabled: true } ],
      office: [ { value: ' ', disabled: true } ],
      dc: [ { value: ' ', disabled: true } ],
      account: [ { value: ' ', disabled: true } ],
    });
    this.setValidationsPt();
    this.getSavedData();
    const checkEnterMargins = this.riskAnalysisForm.value.calculateCommission === '1' ? this.enterMarginsValid : true;
    if (this.riskAnalysisForm.valid && checkEnterMargins) {
      this.formValid.emit({ value: !this.resultNegative, tab: 0 });
    }
    this.formChange();
    if (!this.newContractPymesService.getSavedData().value.savedDataFromDraft) {
      this.subscribeToCupChanges();
      this.subscribeToCifChanges();
    }
    if (!this.isUserSpanish) {
      this.subscribePaymentChanges();
    }
    this.queryApproved.subscribe(data => {
      if (data) {
        this.riskAnalysisForm.controls.cups.disable();
        this.riskAnalysisForm.controls.cif.disable();
        this.riskAnalysisForm.controls.tension.disable();
        this.riskAnalysisForm.controls.cycle.disable();
        this.riskAnalysisForm.controls.period.disable();
        this.riskAnalysisForm.controls.potency.disable();
        this.riskAnalysisForm.controls.customPotency.disable();
        this.riskAnalysisForm.controls.consumption.disable();
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private getTension(): void {
    if (!this.isUserSpanish) {
      const fromDraft = this.newContractPymesService.getSavedData().value?.savedDataFromDraft;
      const analysisData = this.newContractPymesService.getSavedData().value?.analysis;
      const invoiceDate = this.newContractPymesService.getSavedData().value?.payment?.fechaVigenciaFutura ?
        this.utilService.formatDate(this.newContractPymesService.getSavedData().value.payment.fechaVigenciaFutura) : null;
      this.getTensionCyclePeriod(fromDraft, analysisData, invoiceDate);
      if (!fromDraft) {
        this.onChangeCustomPotency();
      }
    }
  }

  private getSavedData(): void {
    this.newContractPymesService.getSavedData().pipe(takeUntil(this.destroyed$)).subscribe(res => {
      if (res?.savedDataFromDraft && res?.analysis && !this.draftLoaded) {
        this.draftLoaded = true;
        const analysisData = this.newContractPymesService.getSavedData().value.analysis;
        const paymentData = this.newContractPymesService.getSavedData().value.payment;
        this.enterMarginsDraft = analysisData.enterMargins;
        // this.repin = analysisData.existeEnRepin;
        if (!this.repin) {
          this.getTension();
        }
        const invoiceDate = this.newContractPymesService.getSavedData().value.payment?.fechaVigenciaFutura ?
          this.utilService.formatDate(this.newContractPymesService.getSavedData().value.payment.fechaVigenciaFutura) : null;
        this.riskAnalysisForm.patchValue({
          cups: analysisData.cups,
          cif: analysisData.cif,
          potency: analysisData.potenciaContratadaPeriodo?.length > 0 ? analysisData.potenciaContratadaPeriodo[ 0 ].toString().replace('.', ',') : null,
          consumption: this.isUserSpanish ? analysisData.consumption : analysisData.consumption?.toString().replace('.', ','),
          fee: analysisData.accessFee || null,
          radioDate: invoiceDate === null ? '1' : '2',
          invoiceDate,
          tension: analysisData.tension,
          cycle: analysisData.cycle,
          period: analysisData.period,
        });
        if (!this.isUserSpanish) {
          this.riskAnalysisForm.patchValue({
            iban: paymentData?.iban || ' ',
            entity: paymentData?.entidad || ' ',
            office: paymentData?.sucursal || ' ',
            dc: paymentData?.dc || ' ',
            account: paymentData?.cuenta || ' ',
            payment: paymentData?.isMultibanco ? '1' : '0',
          });
        }
        this.geographicZone = analysisData.zonaGeograficaCUPS;
        this.setDraftTensionCyclePeriodPotency(analysisData);
        this.commissionTE = analysisData.comisionCanalEnergia;
        this.commissionTP = analysisData.comisionCanalPotencia;
        this.estimatedConsumption = analysisData.consumoEstimadoPeriodo;
        this.contractPotency = analysisData.potenciaContratadaPeriodo;
        this.riskAnalysisForm.controls.cups.disable();
        if (res.aprobado) {
          this.tarifaSipsReal = analysisData.tarifaSipsReal;
          this.queryApproved.next(true);
          this.showApproved = true;
          this.enableQueryButton = false;
          if (!this.hasTDString(this.tarifaSipsReal) && this.isUserSpanish) {
            this.riskAnalysisForm.get('fee').setValue(this.feeList.find(el => el.label === analysisData.accessFee)?.value || null);
            this.feeAux = this.feeList.find(el => el.label === analysisData.accessFee)?.value || null;
            this.riskAnalysisForm.get('fee').enable();
          } else if (!this.hasTDString(this.tarifaSipsReal) && !this.isUserSpanish) {
            this.feeAux = this.riskAnalysisForm.get('tension').value
              + ' - ' + analysisData.cycleName?.split(' - ')[ 0 ]
              + ' - ' + analysisData.periodName;
            this.riskAnalysisForm.get('fee').setValue(this.feeAux);
          } else {
            this.feeAux = analysisData.tarifaSipsReal;
            this.riskAnalysisForm.get('fee').setValue(analysisData.tarifaSipsReal);
          }
          if (this.isUserSpanish || this.repin) {
            this.subscribeOrGetCampaigns(analysisData, invoiceDate);
          }
        } else {
          this.queryApproved.next(false);
          this.showApproved = true;
        }
      } else if (res?.installationFromCups) {
        if (!this.queryApproved.value) {
          this.enableQueryButton = true;
        } else {
          this.enableQueryButton = false;
        }
      }
    });
  }

  private subscribeOrGetCampaigns(analysisData: AnalysisSavedData, invoiceDate: string): void {
    if (this.riskAnalysisForm.get('fee').value || !this.isUserSpanish) {
      this.getCampaignsFiltered(analysisData, invoiceDate);
    } else {
      this.subscribeToRadioDateChanges();
      this.changeDate();
      this.subscribToCampaignChanges();
      this.subscribeToCalculateCommssionChange();
    }
  }

  private formChange(): void {
    this.riskAnalysisForm.statusChanges.pipe(takeUntil(this.destroyed$)).subscribe(result => {
      if (!this.newContractPymesService.getSavedData().value.savedDataFromDraft) {
        const valuesToSave = this.riskAnalysisForm.value;
        valuesToSave.cups = this.riskAnalysisForm.controls.cups.value;
        valuesToSave.consumption = this.riskAnalysisForm.controls.consumption.value?.toString().replace(',', '.');
        valuesToSave.accessFee = this.feeAux || this.riskAnalysisForm.get('fee').value;
        valuesToSave.tarifaSipsReal = this.tarifaSipsReal;
        valuesToSave.cif = this.riskAnalysisForm.controls.cif.value;
        const campaign = this.campaignsListRes.find(
          res => res.codCampaña === this.riskAnalysisForm.controls.campaign.value
        );
        valuesToSave.invoiceDate = this.riskAnalysisForm.get('invoiceDate').value;
        valuesToSave.campaign = (campaign && campaign.codCampaña) || null;
        valuesToSave.campaignName = (campaign && campaign.nombreCampaña) || null;
        const level = this.campaignLevelsList.find(el => el.idNivel === this.riskAnalysisForm.controls.level.value);
        valuesToSave.levelName = (level && level.nombreNivel) || null;
        valuesToSave.zonaGeograficaCUPS = this.geographicZone;
        this.campaignBase = (campaign && campaign.campanaBase) || false;
        valuesToSave.campanaBase = (campaign && campaign.campanaBase) || null;
        valuesToSave.calculateCommission = this.riskAnalysisForm.get('calculateCommission').value || null;
        valuesToSave.enterMargins = this.riskAnalysisForm.get('enterMargins').value || null;
        valuesToSave.calculateMargins = this.riskAnalysisForm.get('calculateMargins').value || null;
        valuesToSave.comisionCanalEnergia = this.commissionTE;
        valuesToSave.comisionCanalPotencia = this.commissionTP;
        valuesToSave.consumoEstimadoPeriodo = this.estimatedConsumption;
        valuesToSave.potenciaContratadaPeriodo = this.contractPotency;
        valuesToSave.tension = this.riskAnalysisForm.controls.tension.value;
        valuesToSave.cycle = this.riskAnalysisForm.controls.cycle.value;
        valuesToSave.period = this.riskAnalysisForm.controls.period.value;
        if (!this.isUserSpanish) {
          valuesToSave.existeEnRepin = this.repin;
          valuesToSave.otraPotencia = this.riskAnalysisForm.get('potency').value === 'Otro';
          valuesToSave.payment = {
            iban: this.riskAnalysisForm.get('iban')?.value,
            entity: this.riskAnalysisForm.get('entity')?.value,
            office: this.riskAnalysisForm.get('office')?.value,
            dc: this.riskAnalysisForm.get('dc')?.value,
            account: this.riskAnalysisForm.get('account')?.value,
            isMultibanco: this.riskAnalysisForm.get('payment')?.value === '1',
          };
        }
        this.newContractPymesService.setSavedData({ analysis: valuesToSave });
        this.savePayment(valuesToSave.invoiceDate);
      } else {
        const valuesToSave = this.newContractPymesService.getSavedData().value.analysis;
        const invoiceDate = this.newContractPymesService.getSavedData().value.payment.fechaVigenciaFutura;
        let campaign;
        if (this.riskAnalysisForm.controls.campaign.value) {
          campaign = this.campaignsListRes.find(
            el => (el.codCampaña === this.riskAnalysisForm.controls.campaign.value)
          );
        } else {
          campaign = this.campaignsListRes.find(
            el => (el.codCampaña === valuesToSave.campaign)
          );
        }
        this.defaultValueCampaign = campaign?.codCampaña || null;
        valuesToSave.campaign = campaign?.codCampaña || valuesToSave.campaign;
        valuesToSave.campaignName = campaign?.nombreCampaña || valuesToSave.campaignName;
        valuesToSave.campanaBase = campaign?.campanaBase || valuesToSave.campanaBase;
        const level = this.campaignLevelsList.find(el => el.idNivel === this.riskAnalysisForm.controls.level.value);
        valuesToSave.levelName = level?.nombreNivel || valuesToSave.levelName;
        valuesToSave.enterMargins = this.riskAnalysisForm.get('enterMargins').value || null;
        this.campaignBase = valuesToSave.campanaBase;
        this.commissionTE = valuesToSave.comisionCanalEnergia;
        this.commissionTP = valuesToSave.comisionCanalPotencia;
        this.estimatedConsumption = valuesToSave.consumoEstimadoPeriodo;
        this.contractPotency = valuesToSave.potenciaContratadaPeriodo;
        this.newContractPymesService.setSavedData({ analysis: valuesToSave });
        this.savePayment(invoiceDate);
      }
      if (this.riskAnalysisForm.status === 'VALID' &&
        (!!this.riskAnalysisForm.controls.cups.value && !!this.riskAnalysisForm.controls.cif.value &&
          (!!this.riskAnalysisForm.controls.consumption.value || this.riskAnalysisForm.controls.consumption.value === 0) &&
          !!this.riskAnalysisForm.controls.campaign.value && !!this.riskAnalysisForm.controls.level.value
        )) {
        this.formValid.emit({ value: !this.resultNegative, tab: 0 });
      } else {
        if (this.campaignBase) {
          this.formValid.emit({ value: !this.resultNegative && this.enterMarginsValid && this.checkPaymentValidation(), tab: 0 });
        } else {
          this.formValid.emit({ value: false, tab: 0 });
        }
      }
    });
  }

  private checkPaymentValidation(): boolean {
    return this.riskAnalysisForm.get('iban').valid
      && this.riskAnalysisForm.get('entity').valid
      && this.riskAnalysisForm.get('office').valid
      && this.riskAnalysisForm.get('dc').valid
      && this.riskAnalysisForm.get('account').valid
      && !this.riskAnalysisForm.hasError('invalid_IBAN');
  }

  private setValidationsPt(): void {
    if (!this.isUserSpanish) {
      this.riskAnalysisForm.get('tension').setValidators([ Validators.required ]);
      this.riskAnalysisForm.get('cycle').setValidators([ Validators.required ]);
      this.riskAnalysisForm.get('period').setValidators([ Validators.required ]);
      this.riskAnalysisForm.get('customPotency').setValidators([ Validators.required, Validators.pattern(this.patternTwoDecimal) ]);
      this.riskAnalysisForm.get('consumption').setValidators([ Validators.required, Validators.pattern(this.patternThreeDecimal) ]);
      this.riskAnalysisForm.get('potency').setValidators([ Validators.required ]);
      this.riskAnalysisForm.get('fee').clearValidators();
    }
  }

  private getTensionCyclePeriod(getCampaigns?: boolean, analysisData?: AnalysisSavedData, invoiceDate?: string): void {
    this.isLoading.emit(true);
    this.newContractPymesService.getTensionCyclePeriod().pipe(takeUntil(this.destroyed$)).subscribe(
      response => {
        if (response.success) {
          this.tensionCyclePeriod = response.data;
          this.tensionList = this.tensionCyclePeriod.tensiones.map(tension => ({ label: tension.descripcion, value: tension.codigoCRM }));
        } else {
          this.utilService.toastErrors(response);
        }
        this.isLoading.emit(false);
        if (getCampaigns) {
          this.setTensionCylePeriod(analysisData);
          this.subscribeOrGetCampaigns(analysisData, invoiceDate);
        }
      },
      error => {
        this.isLoading.emit(false);
        this.utilService.toastErrors(error);
        if (getCampaigns) {
          this.subscribeOrGetCampaigns(analysisData, invoiceDate);
        }
      }
    );
  }

  private setTensionCylePeriod(analysisData: AnalysisSavedData): void {
    this.tensionSelected = this.tensionCyclePeriod.tensiones.find(tension =>
      tension.codigoCRM === this.riskAnalysisForm.get('tension').value
    );
    this.cycleList = this.tensionSelected?.ciclos?.map(cycle => ({ label: cycle.descripcion, value: cycle.codigoCRM }));
    this.cycleSelected = this.tensionSelected?.ciclos?.find(cycle2 => cycle2.codigoCRM === this.riskAnalysisForm.get('cycle').value);
    this.periodSelected = this.cycleSelected?.periodos?.find(period => period.codigoCRM === this.riskAnalysisForm.get('period').value);
    this.periodList = this.cycleSelected?.periodos?.map(period2 => ({ label: period2.descripcion, value: period2.codigoCRM }));
    this.setPotencyOrdened();
    const valuePotency = analysisData.potenciaContratadaPeriodo[ 0 ].toString().replace('.', ',');
    if (this.potencyList.find(potency =>
      parseFloat(potency.value?.replace(',', '.')) === analysisData.potenciaContratadaPeriodo[ 0 ]
    )) {
      this.riskAnalysisForm.get('potency').setValue(valuePotency);
    } else {
      this.riskAnalysisForm.get('potency').setValue('Otro');
      this.riskAnalysisForm.get('customPotency').setValue(valuePotency);
    }
  }

  public onChangeTension(value: string): void {
    const tensionsWithOtherPotency = [ 'AT', 'MT', 'HT' ];
    this.riskAnalysisForm.get('tension').setValue(value);
    this.tensionSelected = this.tensionCyclePeriod.tensiones.find(tension => tension.codigoCRM === value);
    this.cycleList = this.tensionSelected.ciclos.map(cycle => ({ label: cycle.descripcion, value: cycle.codigoCRM }));
    this.riskAnalysisForm.get('cycle').enable();
    this.riskAnalysisForm.get('cycle').setValue(null);
    this.riskAnalysisForm.get('period').setValue(null);
    this.riskAnalysisForm.get('period').disable();
    if (tensionsWithOtherPotency.indexOf(value) >= 0) {
      this.isPotencyDisabled = true;
      this.potencyList = [ { label: this.i18NextService.t('NEW_CONTRACTS.OTHER_POTENCY'), value: 'Otro' } ];
      this.riskAnalysisForm.get('potency').setValue('Otro');
      this.riskAnalysisForm.get('customPotency').disable();
      this.riskAnalysisForm.get('customPotency').setValidators(
        [ Validators.required, Validators.pattern(this.patternTwoDecimal) ]
      );
    } else {
      this.isPotencyDisabled = false;
      this.potencyList = [];
      this.riskAnalysisForm.get('potency').setValue(null);
      this.riskAnalysisForm.get('customPotency').disable();
      this.riskAnalysisForm.get('customPotency').clearValidators();
    }
    this.riskAnalysisForm.get('potency').disable();
    this.riskAnalysisForm.get('customPotency').setValue(null);
    this.riskAnalysisForm.get('customPotency').updateValueAndValidity();
    this.riskAnalysisForm.get('consumption').setValue(null);
    this.riskAnalysisForm.get('consumption').disable();
  }

  public onChangeCycle(value: string): void {
    this.riskAnalysisForm.get('cycle').setValue(value);
    this.cycleSelected = this.tensionSelected.ciclos.find(cycle => cycle.codigoCRM === value);
    this.periodList = this.cycleSelected.periodos.map(period => ({ label: period.descripcion, value: period.codigoCRM }));
    if (this.repin) {
      this.enableTensionCyclePeriodPotencyConsumtion();
    } else {
      this.riskAnalysisForm.get('period').setValue(null);
      this.riskAnalysisForm.get('period').enable();
      if (!this.isPotencyDisabled) {
        this.riskAnalysisForm.get('potency').setValue(null);
      }
      this.riskAnalysisForm.get('potency').disable();
      this.riskAnalysisForm.get('customPotency').setValue(null);
      this.riskAnalysisForm.get('customPotency').disable();
      this.riskAnalysisForm.get('consumption').setValue(null);
      this.riskAnalysisForm.get('consumption').disable();
    }
  }

  public onChangePeriod(value: string): void {
    this.riskAnalysisForm.get('period').setValue(value);
    this.periodSelected = this.cycleSelected.periodos.find(period => period.codigoCRM === value);
    this.setPotencyOrdened();
    if (!this.isPotencyDisabled) {
      this.riskAnalysisForm.get('potency').setValue(null);
      this.riskAnalysisForm.get('potency').enable();
      this.riskAnalysisForm.get('customPotency').disable();
      this.riskAnalysisForm.get('customPotency').clearValidators();
      this.riskAnalysisForm.get('consumption').disable();
    } else {
      this.riskAnalysisForm.get('customPotency').enable();
      this.riskAnalysisForm.get('consumption').enable();
      this.riskAnalysisForm.get('customPotency').setValidators(
        [ Validators.required, Validators.pattern(this.patternTwoDecimal) ]
      );
    }
    this.riskAnalysisForm.get('customPotency').setValue(null);
  }

  public onChangePotency(value: string): void {
    this.riskAnalysisForm.get('potency').setValue(value);
    this.riskAnalysisForm.get('customPotency').setValue(null);
    this.riskAnalysisForm.get('consumption').enable();
    if (value === 'Otro' && !this.isPotencyDisabled) {
      this.riskAnalysisForm.get('customPotency').enable();
      this.riskAnalysisForm.get('customPotency').setValidators(
        [ Validators.required, Validators.pattern(this.patternTwoDecimal) ]
      );
    } else {
      this.riskAnalysisForm.get('customPotency').disable();
      this.riskAnalysisForm.get('customPotency').clearValidators();
    }
    this.riskAnalysisForm.get('customPotency').updateValueAndValidity();
  }

  private onChangeCustomPotency(): void {
    this.riskAnalysisForm.get('customPotency').valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(
      response => {
        if (response && typeof (response) === 'string') {
          const minNumber = parseFloat(this.minPotency?.replace(',', '.'));
          const numberPotency = parseFloat(response?.replace(',', '.'));
          if (numberPotency <= minNumber) {
            this.riskAnalysisForm.get('customPotency').setErrors(
              { ...this.riskAnalysisForm.get('customPotency').errors, min: true }
            );
          } else {
            const errorCustom = this.riskAnalysisForm.get('customPotency').errors;
            delete errorCustom?.min;
            this.riskAnalysisForm.get('customPotency').setErrors(
              errorCustom
            );
          }
        }
      }
    );
  }

  private setPotencyOrdened(): void {
    const aux = [ ...this.periodSelected?.potencias ];
    const indexOther = aux.findIndex(val => (val.valor === 'Otro'));
    if (indexOther !== - 1) {
      aux.splice(indexOther, 1);
    }
    aux.sort((previous, current) => {
      return parseFloat(previous.valor.replace(',', '.')) - parseFloat(current.valor.replace(',', '.'));
    });
    this.potencyList = aux.map(value => ({ label: value.valor, value: value.valor }));
    this.minPotency = this.potencyList[ this.potencyList?.length - 1 ].value;
    if (indexOther !== - 1) {
      this.potencyList.push({ label: this.i18NextService.t('NEW_CONTRACTS.OTHER_POTENCY'), value: 'Otro' });
    }
  }

  private getCampaignsFiltered(analysisData: AnalysisSavedData, invoiceDate: string): void {
    this.isLoading.emit(true);
    if (this.isUserSpanish) {
      this.getCampaignFilteredSpain(analysisData, invoiceDate);
    } else {
      this.getCampaignFilteredPortugal(analysisData, invoiceDate);
    }
  }

  private getCampaignFilteredSpain(analysisData: AnalysisSavedData, invoiceDate: string): void {
    this.newContractPymesService.getCampaignsFiltered(
      this.newContractPymesService.getSavedData().value.contactoCRM,
      analysisData.accessFee,
      analysisData.zonaGeograficaCUPS,
      analysisData.consumption.toString(),
      invoiceDate
    ).pipe(takeUntil(this.destroyed$)).subscribe(
      res2 => {
        this.responseCampaignFilteredSuccess(res2, analysisData, invoiceDate);
      },
      error => {
        this.responseCampaignFilteredError(error);
      }
    );

  }

  private getCampaignFilteredPortugal(analysisData: AnalysisSavedData, invoiceDate: string): void {
    this.newContractPymesService.getCampaignsFilteredPT(
      this.newContractPymesService.getSavedData().value.contactoCRM,
      this.tensionSelected?.idTension?.toString(),
      this.cycleSelected?.idCiclo?.toString(),
      this.riskAnalysisForm.controls.consumption.value.toString(),
      this.periodSelected?.idPeriodo?.toString(),
      this.riskAnalysisForm.get('radioDate').value === '2' ?
        this.utilService.formatDate(this.riskAnalysisForm.get('invoiceDate').value) : null,
    ).pipe(takeUntil(this.destroyed$)).subscribe(
      res2 => {
        this.responseCampaignFilteredSuccess(res2, analysisData, invoiceDate);
      },
      error => {
        this.responseCampaignFilteredError(error);
      }
    );
  }

  private responseCampaignFilteredSuccess(res2: GenericResponse<Campaign[]>, analysisData: AnalysisSavedData, invoiceDate: string): void {
    if (res2.data.length === 0) {
      this.isLoading.emit(false);
      this.enableRadioDateNoCampaign();
      this.toastrService.error('NEW_CONTRACTS.NO_CAMPAIGNS_ERROR');
    } else {
      this.campaignsListRes = res2.data;
      if (this.isUserSpanish) {
        res2.data.forEach(campana => {
          const valueFee = analysisData.accessFee || analysisData.tarifaSipsReal;
          campana.hide = campana.tarifas.every(tarifa => tarifa.nombreTarifa !== valueFee);
        });
      }
      this.campaignsList = [ ...this.mapResponse(res2.data) ];
      if (this.campaignsList.length === 0) {
        this.toastrService.error('NEW_CONTRACTS.NO_CAMPAIGNS_ERROR');
      }
      const valuesToSave = this.newContractPymesService.getSavedData().value.analysis;
      this.selectedCampaign = this.campaignsListRes.find(
        el => ((el.codCampaña === valuesToSave.campaign) || (el.codCampaña === this.riskAnalysisForm.controls.campaign.value))
      );
      this.defaultValueCampaign = this.selectedCampaign?.codCampaña || null;
      valuesToSave.campaign = this.selectedCampaign?.codCampaña || valuesToSave.campaign;
      valuesToSave.campaignName = this.selectedCampaign?.nombreCampaña || valuesToSave.campaignName;
      this.riskAnalysisForm.controls.campaign.patchValue(valuesToSave.campaign);
      if (this.defaultValueCampaign) {
        this.passThrough = this.selectedCampaign?.passThrough;
        this.fijoFlex = this.selectedCampaign?.fijoFlex;
        this.campaignLevelsList = this.campaignsListRes.find(el => el.codCampaña === this.defaultValueCampaign).niveles;
        this.campaignLevels = [ ...this.mapLevels(this.campaignsListRes.find(
          el => el.codCampaña === this.defaultValueCampaign).niveles
        ) ];
        this.levelsSelectDisabled = false;
        this.riskAnalysisForm.controls.level.enable();
        this.defaultValueLevel = this.campaignLevelsList.find(el => el.nombreNivel === valuesToSave.levelName)?.idNivel;
        valuesToSave.levelName = this.campaignLevelsList.find(el =>
          el.nombreNivel === valuesToSave.levelName
        )?.nombreNivel || valuesToSave.levelName;
        this.riskAnalysisForm.controls.level.patchValue(valuesToSave.levelName);
      }
      if (this.riskAnalysisForm.get('fee').value) {
        this.riskAnalysisForm.get('radioDate').enable();
        this.campaignsSelectDisabled = false;
      } else {
        this.riskAnalysisForm.get('radioDate').disable();
        this.campaignsSelectDisabled = true;
      }
      this.isLoading.emit(false);
      if (analysisData.campanaBase && this.selectedCampaign?.idCampaña) {
        this.riskAnalysisForm.get('calculateCommission').enable();
        this.getCampaignDetail(analysisData, this.selectedCampaign);
      } else {
        this.riskAnalysisForm.get('campaign').enable();
        const checkEnterMargins = this.riskAnalysisForm.value.calculateCommission === '1' ? this.enterMarginsValid : true;
        this.formValid.emit({ value: !this.resultNegative && this.riskAnalysisForm.valid && checkEnterMargins, tab: 0 });
        this.campaignBase = false;
      }
      if (!this.isUserSpanish && this.selectedCampaign) {
        this.enablePayment(this.selectedCampaign?.formPago === '300000008');
        this.showBankAccount(
          (this.selectedCampaign?.formPago !== '300000007' && this.selectedCampaign?.formPago !== '300000008') ||
          (this.selectedCampaign?.formPago === '300000008' && this.riskAnalysisForm.get('payment').value === '0')
        );
      }
      this.subscribeToRadioDateChanges();
      this.changeDate();
      this.subscribToCampaignChanges();
      this.subscribeToCalculateCommssionChange();
      valuesToSave.zonaGeograficaCUPS = valuesToSave.zonaGeograficaCUPS || this.geographicZone;
      this.newContractPymesService.setSavedData({ analysis: valuesToSave });
      this.savePayment(invoiceDate);
    }
  }

  private responseCampaignFilteredError(error: HttpErrorResponse): void {
    this.isLoading.emit(false);
    this.utilService.toastErrors(error);
  }

  private getCampaignDetail(analysisData: AnalysisSavedData, campaign: Campaign): void {
    this.isLoading.emit(true);
    this.campaignsService.getCampaignDetail(Number(campaign.idCampaña)).pipe(takeUntil(this.destroyed$)).subscribe(
      response => {
        if (response.success) {
          this.campaignDetail = response.data;
          this.fixPrice = campaign.precioFijo;
          this.findFee(response);
          if (String(analysisData.calculateCommission) === '1') {
            this.greaterEqual100 = this.riskAnalysisForm.get('consumption').value >= 100000;
            this.riskAnalysisForm.get('calculateCommission').setValue(String(analysisData.calculateCommission));
            this.replaceEnterMargins(this.riskAnalysisForm.get('enterMargins.marginsTE'), analysisData.enterMargins.marginsTE);
            this.riskAnalysisForm.get('enterMargins.marginTP')?.setValue(analysisData.enterMargins?.marginTP?.toString().replace('.', ','));
            this.subscribeToEnterMarings();
          } else {
            this.riskAnalysisForm.get('calculateCommission').setValue(String(analysisData.calculateCommission));
            this.valueUnitsTE = analysisData.unitsTE;
            this.valueUnitsTP = analysisData.unitsTP;
            this.riskAnalysisForm.get('unitsTE').setValue(analysisData.unitsTE);
            this.riskAnalysisForm.get('unitsTP').setValue(analysisData.unitsTP);
            this.replaceCalculateMarginsTE(
              this.riskAnalysisForm.get('calculateMargins.marginTE'), analysisData.calculateMargins
            );
            this.replaceCalculateMarginsTP(
              this.riskAnalysisForm.get('calculateMargins.marginTP'), analysisData.calculateMargins
            );
            this.subscribeToCalculateMargings();
            if (
              Object.values(analysisData.calculateMargins[ 'marginTE' ]).every(val => val !== null) &&
              Object.values(analysisData.calculateMargins[ 'marginTP' ]).every(val => val !== null)
            ) {
              this.isUserSpanish ? this.calculatearginMatchPrice() : this.calculatearginMatchPricePT();
              this.showCalculation = true;
            }
          }
        } else {
          this.campaignTE = [];
          this.campaignTP = [];
          this.utilService.toastErrors(response);
        }
        this.isLoading.emit(false);
      },
      error => {
        this.isLoading.emit(false);
        this.utilService.toastErrors(error);
      }
    );
  }

  private subscribeLanguajeChanges(): void {
    this.i18NextService.events.languageChanged.subscribe(() => {
      this.unitsTP = [
        { value: '0', label: this.i18NextService.t('NEW_CONTRACTS.KW_YEAR') },
        { value: '12', label: this.i18NextService.t('NEW_CONTRACTS.KW_MONTH') },
        { value: '365', label: this.i18NextService.t('NEW_CONTRACTS.KW_DAY') }
      ];
      if (!this.repin && this.periodSelected?.potencias?.length > 0) {
        this.setPotencyOrdened();
      }
    });
  }

  public openInfo(): void {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      autoFocus: false,
      height: '333px',
      width: '575px'
    };

    this.dialog.open(CupsDialogComponent, dialogConfig.data);
  }

  public canQueryCredit(disabled?: boolean): boolean {
    let valid;
    if (this.isUserSpanish) {
      valid = !this.riskAnalysisForm.get('cif').invalid || this.riskAnalysisForm.get('cif').disabled;
    } else {
      valid = (!this.riskAnalysisForm.get('cif').invalid || this.riskAnalysisForm.get('cif').disabled) &&
        !this.riskAnalysisForm.get('tension').invalid &&
        !this.riskAnalysisForm.get('cycle').invalid &&
        !this.riskAnalysisForm.get('period').invalid &&
        !this.riskAnalysisForm.get('consumption').invalid;
      if (this.isPotencyDisabled) {
        valid = valid &&
          !this.riskAnalysisForm.get('customPotency').invalid;
      } else {
        valid = valid &&
          !this.riskAnalysisForm.get('potency').invalid &&
          (this.riskAnalysisForm.get('potency').value === 'Otro' ?
            !this.riskAnalysisForm.get('customPotency').invalid : true);
      }
    }
    if (disabled) {
      return !valid;
    }
    return valid;
  }

  public queryCredit(): void {
    this.isLoading.emit(true);
    const savedData = this.newContractPymesService.getSavedData().value;
    const potencyPT = this.riskAnalysisForm.get('potency').value === 'Otro' ?
      this.riskAnalysisForm.get('customPotency').value : this.riskAnalysisForm.get('potency').value;
    const data = {
      codeCIF: this.riskAnalysisForm.controls.cif.value,
      CodeCUPs: this.riskAnalysisForm.value.cups,
      ContactoCRM: savedData.contactoCRM,
      ConsumoEstimado: this.isUserSpanish ? this.consumoEstimado : this.riskAnalysisForm.get('consumption').value?.replace(',', '.'),
      TarifaSips: this.tarifaSipsReal,
      zonaGeograficaCUPS: this.isUserSpanish ? savedData.analysis?.zonaGeograficaCUPS || this.geographicZone : 'Península',
      ComisionCanalEnergia: this.commissionTE,
      ComisionCanalPotencia: this.commissionTP,
      'consumoEstimadoPeriodo.p1': this.isUserSpanish ? this.estimatedConsumption[ 0 ] : 0,
      'consumoEstimadoPeriodo.p2': this.isUserSpanish ? this.estimatedConsumption[ 1 ] : 0,
      'consumoEstimadoPeriodo.p3': this.isUserSpanish ? this.estimatedConsumption[ 2 ] : 0,
      'consumoEstimadoPeriodo.p4': this.isUserSpanish ? this.estimatedConsumption[ 3 ] : 0,
      'consumoEstimadoPeriodo.p5': this.isUserSpanish ? this.estimatedConsumption[ 4 ] : 0,
      'consumoEstimadoPeriodo.p6': this.isUserSpanish ? this.estimatedConsumption[ 5 ] : 0,
      'potenciaContratadaPeriodo.p1': this.isUserSpanish ? this.contractPotency[ 0 ] : potencyPT.replace(',', '.'),
      'potenciaContratadaPeriodo.p2': this.isUserSpanish ? this.contractPotency[ 1 ] : 0,
      'potenciaContratadaPeriodo.p3': this.isUserSpanish ? this.contractPotency[ 2 ] : 0,
      'potenciaContratadaPeriodo.p4': this.isUserSpanish ? this.contractPotency[ 3 ] : 0,
      'potenciaContratadaPeriodo.p5': this.isUserSpanish ? this.contractPotency[ 4 ] : 0,
      'potenciaContratadaPeriodo.p6': this.isUserSpanish ? this.contractPotency[ 5 ] : 0,
      CicloCUPS: this.riskAnalysisForm.get('cycle').value,
      TensionCUPS: this.riskAnalysisForm.get('tension').value,
      PeriodoCups: this.riskAnalysisForm.get('period').value,
      ExisteEnRepin: this.repin,
      OtraPotencia: this.riskAnalysisForm.get('potency').value === 'Otro'
    };
    if (this.isUserSpanish) {
      delete data.ExisteEnRepin;
      delete data.OtraPotencia;
    }
    this.newContractPymesService.getCifValidation(data).pipe(takeUntil(this.destroyed$)).subscribe(
      res => {
        this.isLoading.emit(false);
        this.enableQueryButton = false;
        if (res.success) {
          if (res.data.aprobado) {
            if (!this.hasTDString(this.tarifaSipsReal) && this.isUserSpanish) {
              this.riskAnalysisForm.get('fee').enable();
              this.campaignsSelectDisabled = true;
            } else if (!this.hasTDString(this.tarifaSipsReal) && !this.isUserSpanish) {
              this.feeAux = this.riskAnalysisForm.get('tension').value
                + ' - ' + this.cycleSelected?.descripcion?.split(' - ')[ 0 ]
                + ' - ' + this.periodSelected?.descripcion;
              this.riskAnalysisForm.get('fee').setValue(this.feeAux);
            } else {
              this.feeAux = this.tarifaSipsReal;
              this.riskAnalysisForm.get('fee').setValue(this.tarifaSipsReal);
              this.riskAnalysisForm.get('radioDate').enable();
              this.campaignsSelectDisabled = false;
              this.getCampaing();
            }
            if (!this.isUserSpanish) {
              this.riskAnalysisForm.get('radioDate').enable();
              this.campaignsSelectDisabled = false;
              this.getCampaing();
            }
            this.subscribeToRadioDateChanges();
            this.subscribeToCalculateCommssionChange();
            this.changeDate();
            this.queryApproved.next(true);
            this.showApproved = true;
            this.cdRef.detectChanges();
            const contactoCRM = this.newContractPymesService.getSavedData().value.contactoCRM;
            const dataToSave = res.data;
            dataToSave.contactoCRM = contactoCRM;
            this.newContractPymesService.setSavedData({ business: dataToSave, businessFromCups: true });
            this.draftEnable.emit(true);
          } else {
            this.showApproved = true;
            this.queryApproved.next(false);
            this.riskAnalysisForm.controls.cups.disable();
            this.riskAnalysisForm.controls.cif.disable();
            this.cdRef.detectChanges();
          }
        } else {
          this.utilService.toastErrors(res);
        }
      },
      error => {
        this.isLoading.emit(false);
        this.utilService.toastErrors(error);
      }
    );
  }

  public deleteForm(): void {
    const showDialog = !!localStorage.getItem('show_delete_message');
    if (!showDialog) {
      const dialogConfig = new MatDialogConfig();

      dialogConfig.data = {
        autoFocus: false,
        height: '281px',
        width: '575px'
      };

      const dialogRef = this.dialogDelete.open(DeleteDialogComponent, dialogConfig.data);
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.resetForm();
          this.toastrService.success('NEW_CONTRACTS.DELETE_DIALOG.DELETED_INFO');
        }
      });
    } else {
      this.resetForm();
      this.toastrService.success('NEW_CONTRACTS.DELETE_DIALOG.DELETED_INFO');
    }
  }

  private mapResponse(values): any[] {
    const aux = [];
    values.forEach(element => {
      if (!element.hide) {
        aux.push({ label: element.nombreCampaña, value: element.codCampaña });
      }
    });
    return aux;
  }

  private mapLevels(values): any[] {
    const aux = [];
    values.forEach(element => {
      aux.push({ label: element.nombreNivel, value: element.idNivel });
    });
    return aux;
  }

  public changeCampaign(cod): void {
    this.enterMarginsDraft = null;
    this.campaignLevelsList = this.campaignsListRes.find(el => el.codCampaña === cod).niveles;
    this.campaignLevels = [ ...this.mapLevels(this.campaignsListRes.find(el => el.codCampaña === cod).niveles) ];
    this.riskAnalysisForm.controls.level.patchValue('');
    const campaign = this.campaignsListRes.find(el => el.codCampaña === cod);
    this.defaultValueCampaign = campaign?.codCampaña || null;
    this.riskAnalysisForm.controls.campaign.patchValue(campaign?.codCampaña);
    this.toastrService.success('NEW_CONTRACTS.CAMPAIGN_SELECTED');
    const valuesToSave = this.newContractPymesService.getSavedData().value.analysis;
    valuesToSave.comisionCanalEnergia = this.commissionTE;
    valuesToSave.comisionCanalPotencia = this.commissionTP;
    valuesToSave.consumoEstimadoPeriodo = this.estimatedConsumption;
    valuesToSave.potenciaContratadaPeriodo = this.contractPotency;
    this.campaignBase = campaign?.campanaBase || false;
    this.fixPrice = campaign?.precioFijo || false;
    valuesToSave.campanaBase = campaign?.campanaBase;
    valuesToSave.calculateCommission = this.riskAnalysisForm.get('calculateCommission').value;
    this.newContractPymesService.setSavedData({ analysis: valuesToSave });
    if (!this.isUserSpanish) {
      this.riskAnalysisForm.get('payment').setValue(campaign?.formPago === '300000007' ? '1' : '0', { emitEvent: false });
      this.enablePayment(campaign?.formPago === '300000008');
      this.showBankAccount(
        (campaign?.formPago !== '300000007' && campaign?.formPago !== '300000008') ||
        (campaign?.formPago === '300000008' && this.riskAnalysisForm.get('payment').value === '0')
      );
    }
    if (!campaign.campanaBase) {
      this.resultNegative = false;
      this.resetField(this.riskAnalysisForm.get('enterMargins.marginsTE'));
      this.riskAnalysisForm.get('enterMargins.marginTP')?.reset();
      this.riskAnalysisForm.get('enterMargins.marginTP')?.clearValidators();
      this.riskAnalysisForm.get('enterMargins.marginTP')?.setValue(null);
      this.riskAnalysisForm.get('enterMargins.marginTP')?.updateValueAndValidity();
      this.resetField(this.riskAnalysisForm.get('calculateMargins.marginTE'));
      this.resetField(this.riskAnalysisForm.get('calculateMargins.marginTP'));
    } else {
      this.resultNegative = true;
      this.isLoading.emit(true);
      this.campaignsService.getCampaignDetail(Number(campaign.idCampaña)).pipe(takeUntil(this.destroyed$)).subscribe(
        response => {
          if (response.success) {
            this.campaignDetail = response.data;
            this.findFee(response);
          } else {
            this.campaignTE = [];
            this.campaignTP = [];
            this.campaignAI = [];
            this.campaignKI = [];
            this.campaignFI = [];
            this.campaignCG = [];
            this.campaignGDOS = [];
            this.campaignPFijo = [];
            this.utilService.toastErrors(response);
          }
          this.isLoading.emit(false);
        }, error => {
          this.isLoading.emit(false);
          this.utilService.toastErrors(error);
        }
      );
    }
  }

  public changeLevel(id): void {
    const level = this.campaignLevelsList.find(el => el.idNivel === id);
    this.defaultValueLevel = level?.idNivel;
    this.riskAnalysisForm.controls.level.patchValue(level?.idNivel);
    this.toastrService.success('NEW_CONTRACTS.LEVEL_SELECTED');
  }

  public subscribeToFee(value: string): void {
    if (value) {
      this.campaignsList = [];
      this.defaultValueCampaign = '';
      this.defaultValueLevel = null;
      this.riskAnalysisForm.patchValue({
        campaign: '',
        level: ''
      });
      this.cdRef.detectChanges();
      const valuesToSave = this.newContractPymesService.getSavedData().value.analysis ||
      {
        cups: '',
        cif: '',
        accessFee: '',
        consumption: null,
        campaignName: '',
        campaign: '',
        levelName: '',
        level: null,
        zonaGeograficaCUPS: '',
        campanaBase: ''
      };
      this.feeAux = value;
      valuesToSave.accessFee = value;
      valuesToSave.campanaBase = false;
      this.newContractPymesService.setSavedData({ analysis: valuesToSave });
      this.campaignBase = false;
      this.riskAnalysisForm.get('calculateCommission').setValue('1');
      this.riskAnalysisForm.get('radioDate').enable();
      const valueRadioDate = this.riskAnalysisForm.get('radioDate').value;
      if (valueRadioDate === '1' || (valueRadioDate === '2' && this.riskAnalysisForm.get('invoiceDate').value !== null)) {
        this.campaignsSelectDisabled = false;
      } else {
        this.campaignsSelectDisabled = true;
      }
    }
  }

  private resetForm(cups: string = null, cif: string = null, fieldsPt?: boolean): void {
    const contactoCRM = this.newContractPymesService.getSavedData().value.contactoCRM;
    const valuesPT = {
      tension: this.riskAnalysisForm.get('tension').value,
      cycle: this.riskAnalysisForm.get('cycle').value,
      period: this.riskAnalysisForm.get('period').value,
      potency: this.riskAnalysisForm.get('potency').value,
      customPotency: this.riskAnalysisForm.get('customPotency').value,
      tensionDisable: this.riskAnalysisForm.get('tension').disabled,
      cycleDisable: this.riskAnalysisForm.get('cycle').disabled,
      periodDisable: this.riskAnalysisForm.get('period').disabled,
      potencyDisable: this.riskAnalysisForm.get('potency').disabled,
      consumption: this.riskAnalysisForm.get('consumption').value,
      consumptionDisable: this.riskAnalysisForm.get('consumption').disabled,
    };
    if (!valuesPT.customPotency) {
      delete valuesPT.customPotency;
    }
    this.newContractPymesService.setSavedData({ contactoCRM });
    this.cupsValid = Boolean(cif);
    this.enableQueryButton = Boolean(cif);
    this.queryApproved.next(false);
    this.showApproved = false;
    this.campaignsList = cif ? this.campaignsList : [];
    this.campaignsListRes = cif ? this.campaignsListRes : [];
    this.campaignLevels = cif ? this.campaignLevels : [];
    this.campaignsSelectDisabled = true;
    this.levelsSelectDisabled = true;
    this.riskAnalysisForm = null;
    this.campaignBase = false;
    this.defaultValueCampaign = null;
    this.campaignsSelectDisabled = true;
    this.riskAnalysisForm = this.formBuilder.group({
      cups: [ cif ? cups : '', [ this.utilValidatorsService.validateCUPS, Validators.required, Validators.maxLength(22) ] ],
      cif: [
        { value: cif || '', disabled: !Boolean(cif) },
        [ this.utilValidatorsService.validateCIFNIF, Validators.required, Validators.maxLength(9) ]
      ],
      tension: [ { value: fieldsPt ? valuesPT.tension : null, disabled: fieldsPt ? valuesPT.tensionDisable : true } ],
      cycle: [ { value: fieldsPt ? valuesPT.cycle : null, disabled: fieldsPt ? valuesPT.cycleDisable : true } ],
      period: [ { value: fieldsPt ? valuesPT.period : null, disabled: fieldsPt ? valuesPT.periodDisable : true } ],
      potency: [ { value: fieldsPt ? valuesPT.potency : null, disabled: fieldsPt ? valuesPT.potencyDisable : true } ],
      customPotency: [ { value: fieldsPt ? valuesPT.customPotency : null } ],
      consumption: [ {
        value: fieldsPt ? valuesPT.consumption : (cif ? this.consumoEstimado : ''),
        disabled: fieldsPt ? valuesPT.consumptionDisable : true
      } ],
      fee: [ { value: null, disabled: true }, Validators.required ],
      radioDate: [ { value: '1', disabled: true } ],
      invoiceDate: [ null ],
      campaign: [ { value: '', disabled: true }, Validators.required ],
      level: [ { value: '', disabled: true }, Validators.required ],
      calculateCommission: [ { value: '1', disabled: true } ],
      unitsTE: null,
      unitsTP: null,
      enterMargins: this.enterMargins(),
      calculateMargins: this.calculateMargins(),
      commission: null,
      payment: [ { value: '0', disabled: true }, this.isUserSpanish ? null : Validators.required ],
      iban: [ { value: ' ', disabled: true } ],
      entity: [ { value: ' ', disabled: true } ],
      office: [ { value: ' ', disabled: true } ],
      dc: [ { value: ' ', disabled: true } ],
      account: [ { value: ' ', disabled: true } ],
    });
    this.setValidationsPt();
    if (!this.newContractPymesService.getSavedData().value.savedDataFromDraft) {
      this.subscribeToCupChanges();
      this.subscribeToCifChanges();
      this.onChangeCustomPotency();
      this.subscribePaymentChanges();
    }

    if (cups && !cif) {
      this.riskAnalysisForm.get('cups').patchValue(cups);
    }
    this.riskAnalysisForm.statusChanges.subscribe(result => {
      if (this.riskAnalysisForm.controls.level.enabled && result === 'VALID') {
        if (!this.newContractPymesService.getSavedData().value.savedDataFromDraft) {
          const valuesToSave = this.riskAnalysisForm.value;
          valuesToSave.comisionCanalEnergia = this.commissionTE;
          valuesToSave.comisionCanalPotencia = this.commissionTP;
          valuesToSave.consumoEstimadoPeriodo = this.estimatedConsumption;
          valuesToSave.potenciaContratadaPeriodo = this.contractPotency;
          valuesToSave.cups = this.riskAnalysisForm.controls.cups.value;
          valuesToSave.consumption = this.riskAnalysisForm.controls.consumption.value;
          valuesToSave.accessFee = this.riskAnalysisForm.get('fee').value;
          valuesToSave.cif = this.riskAnalysisForm.controls.cif.value;
          valuesToSave.zonaGeograficaCUPS = this.geographicZone;
          valuesToSave.tensionName = this.tensionSelected?.nombre;
          valuesToSave.cycleName = this.cycleSelected?.nombre;
          valuesToSave.periodName = this.periodSelected?.nombre;
          const campaign = this.campaignsListRes.find(
            res => res.codCampaña === this.riskAnalysisForm.controls.campaign.value
          );
          valuesToSave.campaign = campaign?.codCampaña;
          valuesToSave.campaignName = campaign?.nombreCampaña;
          valuesToSave.campanaBase = campaign?.campanaBase;
          const level = this.campaignLevelsList.find(el => el.idNivel === this.riskAnalysisForm.controls.level.value);
          valuesToSave.levelName = level?.nombreNivel;
          if (!this.isUserSpanish) {
            valuesToSave.existeEnRepin = this.repin;
            valuesToSave.otraPotencia = this.riskAnalysisForm.get('potency').value === 'Otro';
          }
          this.newContractPymesService.setSavedData({ analysis: valuesToSave });
          this.savePayment(this.riskAnalysisForm.get('invoiceDate').value);
        } else {
          const valuesToSave = this.newContractPymesService.getSavedData().value.analysis;
          const campaign = this.campaignsListRes.find(
            res => res.codCampaña === valuesToSave.campaign
          );
          valuesToSave.campaign = campaign?.codCampaña;
          valuesToSave.campaignName = campaign?.nombreCampaña;
          valuesToSave.campanaBase = campaign?.campanaBase;
          const level = this.campaignLevelsList.find(el => el.idNivel === this.riskAnalysisForm.controls.level.value);
          valuesToSave.levelName = level?.nombreNivel;
          this.newContractPymesService.setSavedData({ analysis: valuesToSave });
        }
        this.formValid.emit({ value: !this.resultNegative, tab: 0 });
      } else {
        if (this.campaignBase) {
          this.formValid.emit({ value: !this.resultNegative, tab: 0 });
        } else {
          this.formValid.emit({ value: false, tab: 0 });
        }
      }
    });
    this.draftEnable.emit(false);
    this.cdRef.detectChanges();
  }

  private subscribeToCupChanges(): void {
    this.draftEnable.emit(false);
    this.riskAnalysisForm.controls.cups.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(value => {
      if (this.riskAnalysisForm.controls.cups.valid) {
        if (value !== this.cupsCalled && this.cupsCalled) {
          this.cupsCalled = null;
          this.resetForm(value, null, true);
        } else {
          this.cupsCalled = value;
          if (!this.isUserSpanish && !value.includes('PT0002')) {
            this.toastrService.error('NEW_CONTRACTS.PT_CUPS_VALIDATION_MESSAGE');
            this.cdRef.detectChanges();
          } else {
            this.isLoading.emit(true);
            this.cupsValid = true;
            this.newContractPymesService.getCupsValidation(
              this.riskAnalysisForm.controls.cups.value
            ).pipe(takeUntil(this.destroyed$)).subscribe(
              res => {
                this.isLoading.emit(false);
                if (res.success) {
                  if (!this.isUserSpanish) {
                    // this.repin = !!res.data.datosPortugal;
                    this.resetTensionCyclePeriodPotency();
                  }
                  if (res.data.instalacion) {
                    const installationMap = {
                      idInstalacion: res.data.instalacion.idInstalacion,
                      cifRazonSocial: res.data.instalacion.cifRazonSocial,
                      codigoCRMInstalacion: res.data.instalacion.codigoCRMInstalacion,
                      nombre: res.data.instalacion.nombreInstalacion,
                      cups: res.data.instalacion.cups,
                      tarifaSips: res.data.instalacion.tarifa,
                      nombreTipoViaDireccion: res.data.instalacion.tipoViaDireccion,
                      nombreDireccion: res.data.instalacion.nombreDireccion,
                      numeroDireccion: res.data.instalacion.numeroDireccion,
                      portalDireccion: res.data.instalacion.portalDireccion,
                      escaleraDireccion: res.data.instalacion.escaleraDireccion,
                      pisoDireccion: res.data.instalacion.pisoDireccion,
                      puertaDireccion: res.data.instalacion.puertaDireccion,
                      codPostalDireccion: res.data.instalacion.codPostalDireccion,
                      nombrePoblacionDireccion: res.data.instalacion.nombrePoblacionDireccion,
                      nombreProvinciaDireccion: res.data.instalacion.nombreProvinciaDireccion,
                      codigoPoblacionDireccion: res.data.instalacion.codPoblacionDireccion,
                      codigoProvinciaDireccion: res.data.instalacion.codProvinciaDireccion
                    };
                    this.riskAnalysisForm.controls.cif.disable();
                    this.riskAnalysisForm.get('cif').patchValue(res.data.instalacion.cifRazonSocial);
                    this.newContractPymesService.setSavedData({ installation: installationMap });
                    this.newContractPymesService.setSavedData({ installationFromCups: true });
                  } else {
                    this.riskAnalysisForm.controls.cif.enable();
                  }
                  if (!res.data.datosPortugal) {
                    if (this.riskAnalysisForm.get('cif').value) {
                      this.riskAnalysisForm.get('tension').enable();
                      this.riskAnalysisForm.get('tension').updateValueAndValidity();
                    }
                    this.getTension();
                  } else {
                    this.setCupsTensionRepin(res.data.datosPortugal);
                    if (this.riskAnalysisForm.get('cif').value) {
                      this.enableTensionCyclePeriodPotencyConsumtion();
                    }
                  }
                  const valuesToSave = this.newContractPymesService.getSavedData().value.analysis || {};
                  this.tarifaSipsReal = res.data.tarifaSips;
                  this.commissionTE = res.data.comisionCanalEnergia;
                  this.commissionTP = res.data.comisionCanalPotencia;
                  this.estimatedConsumption = res.data.consumoEstimadoPeriodo;
                  this.contractPotency = res.data.potenciaContratadaPeriodo;
                  this.geographicZone = this.isUserSpanish ? res.data.zonaGeografica : 'Península';
                  valuesToSave[ 'zonaGeograficaCUPS' ] = res.data.zonaGeografica;
                  if (!this.isUserSpanish) {
                    valuesToSave[ 'existeEnRepin' ] = this.repin;
                    valuesToSave[ 'otraPotencia' ] = this.riskAnalysisForm.get('potency').value === 'Otro';
                  }
                  this.newContractPymesService.setSavedData({ analysis: valuesToSave });
                  this.consumoEstimado = res.data.consumoEstimado;
                  if (this.isUserSpanish) {
                    this.riskAnalysisForm.get('consumption').patchValue(res.data.consumoEstimado);
                  }
                } else {
                  this.isLoading.emit(false);
                  this.utilService.toastErrors(res);
                  this.cdRef.detectChanges();
                }
              },
              error => {
                this.isLoading.emit(false);
                this.utilService.toastErrors(error);
                this.cdRef.detectChanges();
              }
            );
          }
        }
      } else {
        if (value === '' || !value) {
          this.resetForm(null, null, true);
          this.estimatedConsumption = [];
          this.contractPotency = [];
        }
      }
    });
    this.subscribToCampaignChanges();
  }

  private subscribToCampaignChanges(): void {
    this.riskAnalysisForm.controls.campaign.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(value => {
      if (value) {
        this.riskAnalysisForm.controls.level.enable();
        this.riskAnalysisForm.get('level').setValue(null);
        this.levelsSelectDisabled = false;
        const analysisData = this.newContractPymesService.getSavedData().value.analysis;
        this.defaultValueLevel = null;
        analysisData.levelName = null;
        analysisData.level = null;
        this.newContractPymesService.setSavedData({ analysis: analysisData });
        this.selectedCampaign = this.campaignsListRes.find(campaign => campaign.codCampaña === value);
        this.passThrough = this.selectedCampaign.passThrough;
        this.fijoFlex = this.selectedCampaign.fijoFlex;
        if (this.campaignBase) {
          this.greaterEqual100 = this.riskAnalysisForm.get('consumption').value >= 100000;
          this.riskAnalysisForm.get('calculateCommission').setValue('1');
          this.riskAnalysisForm.get('calculateCommission').enable();
          this.resetField(this.riskAnalysisForm.get('calculateMargins.marginTE'));
          this.resetField(this.riskAnalysisForm.get('calculateMargins.marginTP'));
        } else {
          this.riskAnalysisForm.get('calculateCommission').disable();
          this.resetField(this.riskAnalysisForm.get('enterMargins.marginsTE'));
          this.riskAnalysisForm.get('enterMargins.marginTP')?.reset();
          this.riskAnalysisForm.get('enterMargins.marginTP')?.clearValidators();
          this.riskAnalysisForm.get('enterMargins.marginTP')?.setValue(null);
          this.riskAnalysisForm.get('enterMargins.marginTP')?.updateValueAndValidity();
          this.resetField(this.riskAnalysisForm.get('calculateMargins.marginTE'));
          this.resetField(this.riskAnalysisForm.get('calculateMargins.marginTP'));
        }
      }
    });
  }

  private subscribeToCifChanges(): void {
    this.riskAnalysisForm.controls.cif.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(value => {
      if (this.riskAnalysisForm.controls.cif.valid) {
        this.resetForm(this.riskAnalysisForm.value.cups, value, true);
        if (!this.isUserSpanish) {
          if (this.repin) {
            this.enableTensionCyclePeriodPotencyConsumtion();
          } else {
            this.riskAnalysisForm.get('tension').enable();
            this.riskAnalysisForm.get('tension').updateValueAndValidity();
          }
        }
      }
    });
  }

  private subscribeToRadioDateChanges(): void {
    this.riskAnalysisForm.get('radioDate').valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(value => {
      const valuesToSave = this.newContractPymesService.getSavedData().value.analysis;
      if (value === '2') {
        this.riskAnalysisForm.get('invoiceDate').setValidators(Validators.required);
        this.riskAnalysisForm.get('invoiceDate').setValue(null);
        this.riskAnalysisForm.get('campaign').setValue(null);
        this.campaignsList = [];
        this.defaultValueCampaign = null;
        this.campaignsSelectDisabled = true;
        this.riskAnalysisForm.get('level').setValue(null);
        this.campaignLevels = [];
        this.defaultValueLevel = null;
        this.levelsSelectDisabled = true;
        valuesToSave.campaign = null;
        valuesToSave.campaignName = null;
        valuesToSave.levelName = null;
      } else {
        this.riskAnalysisForm.get('campaign').setValue(null);
        this.campaignsList = [];
        this.defaultValueCampaign = null;
        this.campaignsSelectDisabled = false;
        this.riskAnalysisForm.get('level').setValue(null);
        this.campaignLevels = [];
        this.defaultValueLevel = null;
        this.levelsSelectDisabled = true;
        valuesToSave.campaign = null;
        valuesToSave.campaignName = null;
        valuesToSave.levelName = null;
        this.riskAnalysisForm.get('invoiceDate').reset({ emitEvent: false });
        this.riskAnalysisForm.get('invoiceDate').clearValidators();
        this.riskAnalysisForm.get('invoiceDate').setValue(null);
      }
      this.campaignBase = false;
      valuesToSave.campanaBase = false;
      valuesToSave.calculateCommission = this.riskAnalysisForm.get('calculateCommission').value;
      this.newContractPymesService.setSavedData({ analysis: valuesToSave });
      this.greaterEqual100 = this.riskAnalysisForm.get('consumption').value >= 100000;
      this.riskAnalysisForm.get('calculateCommission').setValue('1');
      this.resetField(this.riskAnalysisForm.get('enterMargins.marginsTE'));
      this.riskAnalysisForm.get('enterMargins.marginTP')?.reset();
      this.riskAnalysisForm.get('enterMargins.marginTP')?.clearValidators();
      this.riskAnalysisForm.get('enterMargins.marginTP')?.setValue(null);
      this.riskAnalysisForm.get('enterMargins.marginTP')?.updateValueAndValidity();
      this.resetField(this.riskAnalysisForm.get('calculateMargins.marginTE'));
      this.resetField(this.riskAnalysisForm.get('calculateMargins.marginTP'));
      this.riskAnalysisForm.get('payment').setValue('0');
      this.enablePayment(false);
      this.showBankAccount(false);
    });
  }

  private changeDate(): void {
    this.riskAnalysisForm.get('invoiceDate').valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(value => {
      this.savePayment(value);
      if (value === null) {
        this.campaignsSelectDisabled = !this.feeAux;
      } else {
        this.campaignsSelectDisabled = false;
        this.getCampaing();
      }
    });
  }

  private getCampaing(): void {
    this.isLoading.emit(true);
    if (this.isUserSpanish) {
      this.getCampaignSpain();
    } else {
      this.getCampaignPortugal();
    }
  }

  private getCampaignSpain(): void {
    const analysisData = this.newContractPymesService.getSavedData().value.analysis;
    this.newContractPymesService.getCampaignsFiltered(
      this.newContractPymesService.getSavedData().value.contactoCRM,
      this.feeAux || this.riskAnalysisForm.get('fee').value,
      analysisData?.zonaGeograficaCUPS || this.geographicZone,
      analysisData?.consumption || this.riskAnalysisForm.controls.consumption.value,
      this.riskAnalysisForm.get('radioDate').value === '2' ?
        this.utilService.formatDate(this.riskAnalysisForm.get('invoiceDate').value) : null,
    ).pipe(takeUntil(this.destroyed$)).subscribe(
      response => {
        this.campaignResponseSuccess(response);
      },
      error => {
        this.campaignResponseError(error);
      }
    );
  }

  private getCampaignPortugal(): void {
    this.newContractPymesService.getCampaignsFilteredPT(
      this.newContractPymesService.getSavedData().value.contactoCRM,
      this.tensionSelected.idTension.toString(),
      this.cycleSelected.idCiclo.toString(),
      this.riskAnalysisForm.controls.consumption.value.toString(),
      this.periodSelected.idPeriodo.toString(),
      this.riskAnalysisForm.get('radioDate').value === '2' ?
        this.utilService.formatDate(this.riskAnalysisForm.get('invoiceDate').value) : null,
    ).pipe(takeUntil(this.destroyed$)).subscribe(
      response => {
        this.campaignResponseSuccess(response);
      },
      error => {
        this.campaignResponseError(error);
      }
    );
  }

  private campaignResponseSuccess(response: GenericResponse<Campaign[]>): void {
    if (response.data.length === 0 && response.success) {
      this.riskAnalysisForm.get('campaign').setValue(null);
      this.campaignsList = [];
      this.toastrService.error('NEW_CONTRACTS.NO_CAMPAIGNS_ERROR');
    } else if (response.success) {
      this.campaignsListRes = response.data;
      if (this.isUserSpanish) {
        response.data.forEach(campana => {
          campana.hide = campana.tarifas.every(tarifa => tarifa.nombreTarifa !== this.feeAux);
        });
      }
      this.campaignsList = [ ...this.mapResponse(response.data) ];
      if (this.campaignsList.length === 0) {
        this.toastrService.error('NEW_CONTRACTS.NO_CAMPAIGNS_ERROR');
      }
      if (!this.campaignsList.some((res: any) => res.value === this.riskAnalysisForm.get('campaign').value) &&
        this.riskAnalysisForm.get('campaign').value
      ) {
        this.riskAnalysisForm.get('campaign').setValue(null);
        this.toastrService.error('NEW_CONTRACTS.NO_EXIST');
      }
    } else {
      this.riskAnalysisForm.get('campaign').setValue(null);
      this.campaignsList = [];
      this.utilService.toastErrors(response);
    }
    this.isLoading.emit(false);
  }

  private campaignResponseError(error: HttpErrorResponse): void {
    this.riskAnalysisForm.get('campaign').setValue(null);
    this.campaignsList = [];
    this.isLoading.emit(false);
    this.utilService.toastErrors(error);
  }

  private savePayment(invoiceDate: string): void {
    const savedData = this.newContractPymesService.getSavedData().value;
    this.newContractPymesService.setSavedData({
      payment: {
        contactoCRM: savedData?.contactoCRM || null,
        idBorrador: savedData?.idBorrador || null,
        codidoInstalacion: savedData?.codigoInstalacion || null,
        codigoCampana: savedData?.analysis?.campaign || null,
        isMultibanco: this.riskAnalysisForm.get('payment')?.value === '1',
        nombreNivel: savedData?.analysis?.levelName || savedData?.analysis?.level || null,
        nombreTipoViaDireccion: savedData?.payment?.nombreTipoViaDireccion || null,
        nombreDireccion: savedData?.payment?.nombreDireccion || null,
        numeroDireccion: savedData?.payment?.numeroDireccion || null,
        portalDireccion: savedData?.payment?.portalDireccion || null,
        escaleraDireccion: savedData?.payment?.escaleraDireccion || null,
        pisoDireccion: savedData?.payment?.pisoDireccion || null,
        puertaDireccion: savedData?.payment?.puertaDireccion || null,
        codPostalDireccion: savedData?.payment?.codPostalDireccion || null,
        nombrePoblacionDireccion: savedData?.payment?.nombrePoblacionDireccion || null,
        nombreProvinciaDireccion: savedData?.payment?.nombreProvinciaDireccion || null,
        nombreFirmante: savedData?.payment?.nombreFirmante || null,
        apellidosFirmante: savedData?.payment?.apellidosFirmante || null,
        dniFirmante: savedData?.payment?.dniFirmante || null,
        movilFirmante: savedData?.payment?.movilFirmante || null,
        mailFirmante: savedData?.payment?.mailFirmante || null,
        iban: this.riskAnalysisForm.get('iban')?.value || null,
        entidad: this.riskAnalysisForm.get('entity')?.value || null,
        sucursal: this.riskAnalysisForm.get('office')?.value || null,
        dc: this.riskAnalysisForm.get('dc')?.value || null,
        cuenta: this.riskAnalysisForm.get('account')?.value || null,
        codigoPoblacionDireccion: savedData?.payment?.codigoPoblacionDireccion || null,
        fechaVigenciaFutura: invoiceDate ? this.utilService.formatDate(invoiceDate) : null
      }
    });
  }

  private enterMargins(): FormGroup {
    if (this.isUserSpanish) {
      return this.formBuilder.group({
        marginTP: new FormControl(null),
        marginsTE: this.formBuilder.group({
          p1: new FormControl(null),
          p2: new FormControl(null),
          p3: new FormControl(null),
          p4: new FormControl(null),
          p5: new FormControl(null),
          p6: new FormControl(null),
        })
      });
    } else {
      return this.formBuilder.group({
        marginsTE: this.formBuilder.group({
          p1: new FormControl(null),
          p2: new FormControl(null),
          p3: new FormControl(null),
          p4: new FormControl(null),
          p5: new FormControl(null),
          p6: new FormControl(null),
        })
      });
    }
  }

  private calculateMargins(): FormGroup {
    if (this.isUserSpanish) {
      return this.formBuilder.group({
        marginTP: this.formBuilder.group({
          p1: new FormControl(null),
          p2: new FormControl(null),
          p3: new FormControl(null),
          p4: new FormControl(null),
          p5: new FormControl(null),
          p6: new FormControl(null),
        }),
        marginTE: this.formBuilder.group({
          p1: new FormControl(null),
          p2: new FormControl(null),
          p3: new FormControl(null),
          p4: new FormControl(null),
          p5: new FormControl(null),
          p6: new FormControl(null),
        })
      });
    } else {
      return this.formBuilder.group({
        marginTE: this.formBuilder.group({
          p1: new FormControl(null),
          p2: new FormControl(null),
          p3: new FormControl(null),
          p4: new FormControl(null),
        })
      });
    }
  }

  private setValidatorFieldRequired(form: any): void {
    if (form) {
      Object.keys(form.controls).forEach(field => {
        if ((field === 'marginTE') || (field === 'marginsTE')) {
          this.greaterEqual100 = this.riskAnalysisForm.get('consumption').value >= 100000;
          form.get(field).setValidators([
            Validators.required, Validators.min(0),
            Validators.max(this.isUserSpanish ? (this.greaterEqual100 ? 24.999 : 49.999) : 25.999),
            Validators.pattern('([0-9]{1,2}(,[0-9]{1,3})?)')
          ]);
        } else if (field === 'marginTP') {
          form.get(field).setValidators([ Validators.required, Validators.min(0), Validators.max(24.999) ]);
        } else if (field !== 'iban' && field !== 'entity' && field !== 'office' && field !== 'dc' && field !== 'account') {
          form.get(field).setValidators([ Validators.required ]);
        }
        form.get(field).updateValueAndValidity();
      });
    }
  }

  private resetField(form: any, validator: boolean = true): void {
    if (form) {
      Object.keys(form.controls).forEach(field => {
        form.get(field).reset();
        if (validator) {
          form.get(field).clearValidators();
        }
        form.get(field).setValue(null);
        form.get(field).updateValueAndValidity();
      });
    }
  }

  private setDisabledField(form: any, indexControl: number): void {
    Object.keys(form.controls).forEach((field, index) => {
      if (index + 1 > indexControl) {
        form.get(field).disable();
        form.get(field).setValue(0);
      }
      form.get(field).updateValueAndValidity();
    });
  }

  private setEnabledField(form: any): void {
    if (form) {
      Object.keys(form.controls).forEach((field, index) => {
        form.get(field).enable();
        form.get(field).updateValueAndValidity();
      });
    }
  }

  private subscribeToCalculateCommssionChange(): void {
    this.riskAnalysisForm.get('calculateCommission').valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(value => {
      if (this.campaignBase) {
        this.showCalculation = false;
        if (value === '2') {
          this.resultNegative = true;
          this.riskAnalysisForm.get('unitsTE').setValue(this.valueUnitsTE);
          this.riskAnalysisForm.get('unitsTP').setValue(this.valueUnitsTP);
          this.resetField(this.riskAnalysisForm.get('calculateMargins.marginTE'), false);
          this.resetField(this.riskAnalysisForm.get('calculateMargins.marginTP'), false);
          this.setValidatorFieldRequired(this.riskAnalysisForm.get('calculateMargins.marginTE'));
          this.setValidatorFieldRequired(this.riskAnalysisForm.get('calculateMargins.marginTP'));
          if (this.feeAux === '2.0TD') {
            this.setDisabledField(this.riskAnalysisForm.get('calculateMargins.marginTE'), 3);
            this.setDisabledField(this.riskAnalysisForm.get('calculateMargins.marginTP'), 2);
          } else {
            this.setEnabledField(this.riskAnalysisForm.get('calculateMargins.marginTE'));
            this.setEnabledField(this.riskAnalysisForm.get('calculateMargins.marginTP'));
          }
          this.resetField(this.riskAnalysisForm.get('enterMargins.marginsTE'));
          this.riskAnalysisForm.get('enterMargins.marginTP')?.reset();
          this.riskAnalysisForm.get('enterMargins.marginTP')?.clearValidators();
          this.riskAnalysisForm.get('enterMargins.marginTP')?.setValue(null);
          this.riskAnalysisForm.get('enterMargins.marginTP')?.updateValueAndValidity();
          this.riskAnalysisForm.get('level').setValue(null);
          this.subscribeToEnterMarings();
          this.formValid.emit({ value: false, tab: 0 });
        } else {
          this.resetField(this.riskAnalysisForm.get('calculateMargins.marginTE'));
          this.resetField(this.riskAnalysisForm.get('calculateMargins.marginTP'));
          this.riskAnalysisForm.get('level').setValue(null);
          this.riskAnalysisForm.get('level').setValidators([]);
          this.riskAnalysisForm.get('level').updateValueAndValidity();
          this.subscribeToCalculateMargings();
          const checkEnterMargins = this.riskAnalysisForm.value.calculateCommission === '1' ? this.enterMarginsValid : true;
          this.formValid.emit({ value: this.riskAnalysisForm.valid && checkEnterMargins, tab: 0 });
        }
      }
    });
  }

  public calculatearginMatchPrice(): void {
    this.showCalculation = true;
    // const inputsTE = this.pushInputTETP(this.riskAnalysisForm.get('calculateMargins.marginTE'));
    // const inputsTP = this.pushInputTETP(this.riskAnalysisForm.get('calculateMargins.marginTP'));
    // const sumTicketTE = [];
    // const sumTicketAccionaTE = [];
    // const sumTicketTP = [];
    // const sumTicketAccionaTP = [];
    // for (let i = 0; i < 6; i++) {
    //   const calcSelectTE = this.riskAnalysisForm.get('unitsTE').value !== '0' ?
    //     inputsTE[ i ] / this.riskAnalysisForm.get('unitsTE').value : inputsTE[ i ];
    //   const calcSelectTP = this.riskAnalysisForm.get('unitsTP').value !== '0' ?
    //     inputsTP[ i ] * this.riskAnalysisForm.get('unitsTP').value : inputsTP[ i ];
    //   const calcTicketTE = calcSelectTE * this.estimatedConsumption[ i ];
    //   const calcTicketAccionaTE = (this.campaignTE[ i ] / 1000) * this.estimatedConsumption[ i ];
    //   const calcTicketTP = calcSelectTP * this.contractPotency[ i ];
    //   const calcTicketAccionaTP = this.campaignTP[ i ] * this.contractPotency[ i ];
    //   sumTicketTE.push(calcTicketTE);
    //   sumTicketAccionaTE.push(calcTicketAccionaTE);
    //   sumTicketTP.push(calcTicketTP);
    //   sumTicketAccionaTP.push(calcTicketAccionaTP);
    // }
    // const ticketTE = sumTicketTE.reduce((total, val) => total + val, 0);
    // const ticketAccionaTE = sumTicketAccionaTE.reduce((total, val) => total + val, 0);
    // const ticketTP = sumTicketTP.reduce((total, val) => total + val, 0);
    // const ticketAccionaTP = sumTicketAccionaTP.reduce((total, val) => total + val, 0);
    // const sumRowEstimatedConsumption = this.estimatedConsumption.reduce((total, val) => total + val, 0);
    // const sumRowContractPotency = this.contractPotency.reduce((total, val) => total + val, 0);
    // const resultCalcTE = ((ticketTE - ticketAccionaTE) / parseFloat(sumRowEstimatedConsumption) * 1000) / 1.015;
    // const resultCalcTP = (ticketTP - ticketAccionaTP) / parseFloat(sumRowContractPotency);
    // const commissionTE = ((((sumRowEstimatedConsumption / 1000) * this.commissionTE) / 100) * resultCalcTE);
    // const commissionTP = (((sumRowContractPotency * this.commissionTP) / 100) * resultCalcTP);
    // this.resultTE = [];
    // this.resultTP = [];
    // this.campaignTE.forEach((valTE, index) => {
    //   if (this.feeAux === '2.0TD' && index > 2) {
    //     this.resultTE.push(0);
    //   } else {
    //     const calc = ((resultCalcTE / 1000) * 1.015) + (valTE / 1000);
    //     this.resultTE.push(parseFloat(calc.toString().match(/^-?\d+(?:\.\d{0,6})?/)[ 0 ]));
    //   }
    // });
    // this.campaignTP.forEach((valTP, index) => {
    //   if (this.feeAux === '2.0TD' && index > 1) {
    //     this.resultTP.push(0);
    //   } else {
    //     const calc = (resultCalcTP * 1.015) + valTP;
    //     this.resultTP.push(parseFloat(calc.toString().match(/^-?\d+(?:\.\d{0,6})?/)[ 0 ]));
    //   }
    // });
    // const commissionFinal = commissionTE + commissionTP;
    // this.resultCalculation = commissionFinal >= 0;
    // if (commissionTE <= 0 || commissionTP <= 0) {
    //   this.resultNegative = true;
    // } else {
    //   this.resultNegative = false;
    // }
    // this.riskAnalysisForm.get('enterMargins.marginsTE').setValue(parseFloat(String(resultCalcTE).match(/^-?\d+(?:\.\d{0,2})?/)[ 0 ]));
    // this.riskAnalysisForm.get('enterMargins.marginTP').setValue(parseFloat(String(resultCalcTP).match(/^-?\d+(?:\.\d{0,2})?/)[ 0 ]));
    // this.riskAnalysisForm.get('commission').setValue(parseFloat(String(commissionFinal).match(/^-?\d+(?:\.\d{0,2})?/)[ 0 ]));
    this.canSettlementsCommission();
    this.saveDataMargins();
  }

  public calculatearginMatchPricePT(): void {
    this.showCalculation = true;
    // const inputsTE = this.pushInputTETP(this.riskAnalysisForm.get('calculateMargins.marginTE'));
    // const sumTicketTE = [];
    // const sumTicketAccionaTE = [];
    // for (let i = 0; i < 4; i++) {
    //   const calcSelectTE = this.riskAnalysisForm.get('unitsTE').value !== '0' ?
    //     inputsTE[ i ] / this.riskAnalysisForm.get('unitsTE').value : inputsTE[ i ];
    //   const calcTicketTE = calcSelectTE * this.estimatedConsumption[ i ];
    //   const calcTicketAccionaTE = (this.campaignTE[ i ] / 1000) * this.estimatedConsumption[ i ];
    //   sumTicketTE.push(calcTicketTE);
    //   sumTicketAccionaTE.push(calcTicketAccionaTE);
    // }
    // const ticketTE = sumTicketTE.reduce((total, val) => total + val, 0);
    // const ticketAccionaTE = sumTicketAccionaTE.reduce((total, val) => total + val, 0);
    // const sumRowEstimatedConsumption = this.estimatedConsumption.reduce((total, val) => total + val, 0);
    // const resultCalcTE = ((ticketTE - ticketAccionaTE) / parseFloat(sumRowEstimatedConsumption) * 1000) / 1.015 || 0;
    // const commissionTE = ((((sumRowEstimatedConsumption / 1000) * this.commissionTE) / 100) * resultCalcTE);
    // this.resultTE = [];
    // this.campaignTE.forEach((valTE, index) => {
    //   if (this.feeAux === '2.0TD' && index > 2) {
    //     this.resultTE.push(0);
    //   } else {
    //     const calc = ((resultCalcTE / 1000) * 1.015) + (valTE / 1000);
    //     this.resultTE.push(parseFloat(calc.toString().match(/^-?\d+(?:\.\d{0,6})?/)[ 0 ]));
    //   }
    // });
    // const commissionFinal = commissionTE;
    // this.resultCalculation = commissionFinal >= 0;
    // if (commissionTE <= 0) {
    //   this.resultNegative = true;
    // } else {
    //   this.resultNegative = false;
    // }
    // this.riskAnalysisForm.get('enterMargins.marginsTE').setValue(parseFloat(String(resultCalcTE).match(/^-?\d+(?:\.\d{0,2})?/)[ 0 ]));
    // this.riskAnalysisForm.get('commission').setValue(parseFloat(String(commissionFinal).match(/^-?\d+(?:\.\d{0,2})?/)[ 0 ]));
    this.canSettlementsCommission();
    this.saveDataMargins();
  }

  // private pushInputTETP(form: any): any[] {
  //   const inputs = [];
  //   if (form) {
  //     Object.keys(form.controls).forEach(field => {
  //       inputs.push(form.get(field).value ? form.get(field).value.replace(',', '.') : form.get(field).value);
  //     });
  //   }
  //   return inputs;
  // }

  private saveDataMargins(): void {
    const valuesToSave = this.newContractPymesService.getSavedData().value.analysis;
    valuesToSave.campanaBase = this.campaignBase;
    valuesToSave.calculateCommission = this.riskAnalysisForm.get('calculateCommission').value;
    valuesToSave.unitsTE = this.riskAnalysisForm.get('unitsTE').value;
    valuesToSave.unitsTP = this.riskAnalysisForm.get('unitsTP').value;
    valuesToSave.enterMargins = this.replaceEnterMarginsToSave(this.riskAnalysisForm.get('enterMargins').value);
    valuesToSave.calculateMargins = this.replaceCalculateMarginsToSave(this.riskAnalysisForm.get('calculateMargins').value);
    valuesToSave.levelName = null;
    this.newContractPymesService.setSavedData({ analysis: valuesToSave });
  }

  private findFee(val): void {
    const findFee = val.data.find(a => a.zonasGeograficas.find(zone => zone.nombreZona === this.geographicZone).tarifas.find(b =>
      this.feeAux.includes('S/C - ') ? b.nombreTarifa === this.feeAux.replace('S/C - ', '') : b.nombreTarifa === this.feeAux
    ));
    const powerTerms = findFee.zonasGeograficas.find(zone => zone.nombreZona === this.geographicZone).tarifas.find(el =>
      this.feeAux.includes('S/C - ') ? el.nombreTarifa === this.feeAux.replace('S/C - ', '') : el.nombreTarifa === this.feeAux
    );
    this.selectedCampaignFee = powerTerms;
    this.campaignTE = [];
    this.campaignTP = [];
    this.campaignAI = [];
    this.campaignKI = [];
    this.campaignFI = [];
    this.campaignCG = [];
    this.campaignGDOS = [];
    this.campaignPFijo = [];
    const pLenght = this.isUserSpanish ? 6 : 4;
    for (let i = 0; i < pLenght; i++) {
      let priceTE = 0;
      if (!this.isUserSpanish && this.selectedCampaign?.precioFijo) {
        priceTE = !powerTerms[`precio_P${i + 1}`] ? 0 : powerTerms[`precio_P${i + 1}`];
      } else {
        priceTE = !powerTerms[`precioFinal_P${i + 1}`] ? 0 : powerTerms[`precioFinal_P${i + 1}`];
      }
      const priceRealTE = !powerTerms[ `tE_P${i + 1}` ] ? 0 : powerTerms[ `tE_P${i + 1}` ];
      const priceTP = powerTerms[ `tP_P${i + 1}` ] === null ? null : powerTerms[ `tP_P${i + 1}` ];
      const priceAI = !powerTerms[ `ai_P${i + 1}` ] ? 0 : powerTerms[ `ai_P${i + 1}` ];
      const priceKI = !powerTerms[ `ki_P${i + 1}` ] ? 0 : powerTerms[ `ki_P${i + 1}` ];
      this.campaignTE.push(priceTE);
      this.camaignRealTE.push(priceRealTE / 1000);
      this.campaignTP.push(priceTP);
      this.campaignAI.push(priceAI);
      this.campaignKI.push(priceKI);
      this.campaignFI.push(!powerTerms[ `fi_P${i + 1}` ] ? null : powerTerms[ `fi_P${i + 1}` ]);
      this.campaignCG.push(!powerTerms[ `cG_P${i + 1}` ] ? null : powerTerms[ `cG_P${i + 1}` ]);
      this.campaignGDOS.push(!powerTerms[ `gdOs_P${i + 1}` ] ? null : powerTerms[ `gdOs_P${i + 1}` ]);
      this.campaignPFijo.push(!powerTerms[ `pFijo_P${i + 1}` ] ? null : powerTerms[ `pFijo_P${i + 1}` ]);
    }
  }

  private replaceEnterMargins(form: any, object: any): void {
    Object.keys(form.controls).forEach(field => {
      if (object && object[ field ] !== null && object[ field ] !== undefined) {
        form.get(field).setValue(String(object[ field ]).replace('.', ','));
      }
    });
  }

  private replaceCalculateMarginsTE(form: any, object: any): void {
    Object.keys(form.controls).forEach((field, index) => {
      if (object.marginTE[ `p${index + 1}` ] !== null && object.marginTE[ `p${index + 1}` ] !== undefined) {
        form.get(field).setValue(String(object.marginTE[ `p${index + 1}` ]).replace('.', ','));
      }
    });
  }

  private replaceCalculateMarginsTP(form: any, object: any): void {
    Object.keys(form.controls).forEach((field, index) => {
      if (object.marginTP[ `p${index + 1}` ] !== null && object.marginTP[ `p${index + 1}` ] !== undefined) {
        form.get(field).setValue(String(object.marginTP[ `p${index + 1}` ]).replace('.', ','));
      }
    });
  }

  private replaceEnterMarginsToSave(object: any): any {
    Object.keys(object).forEach(key => {
      if (key === 'marginsTE') {
        Object.keys(object[ key ]).forEach(item => {
          object[ key ][ item ] = object[ key ][ item ] ?
            parseFloat(String(object[ key ][ item ]).replace(',', '.')) : object[ key ][ item ];
        });
      } else {
        object[ key ] = object[ key ] ? parseFloat(String(object[ key ]).replace(',', '.')) : object[ key ];
      }
    });
    return object;
  }

  private replaceCalculateMarginsToSave(object: any): any {
    Object.keys(object).forEach(key => {
      if ((key === 'marginTE') || (key === 'marginsTE')) {
        Object.keys(object[ key ]).forEach(item => {
          object[ key ][ item ] = object[ key ][ item ] ?
            parseFloat(String(object[ key ][ item ]).replace(',', '.')) : object[ key ][ item ];
        });
      }
      if (key === 'marginTP') {
        Object.keys(object.marginTP).forEach(item => {
          object.marginTP[ item ] = object.marginTP[ item ] ?
            parseFloat(String(object.marginTP[ item ]).replace(',', '.')) : object.marginTP[ item ];
        });
      }
    });
    return object;
  }

  private subscribeToEnterMarings(): void {
    this.riskAnalysisForm.get('enterMargins').valueChanges.subscribe(status => {
      this.replaceEnterMarginsToSave(status);
      this.saveDataMargins();
    });
  }

  private subscribeToCalculateMargings(): void {
    this.riskAnalysisForm.get('calculateMargins').valueChanges.subscribe(status => {
      this.replaceCalculateMarginsToSave(status);
      this.saveDataMargins();
    });
  }

  public hasTDString(feeValue: string): boolean {
    return !!feeValue ? feeValue.slice(-2).toUpperCase() === 'TD' || feeValue.slice(-4).toUpperCase() === 'TDVE' : false;
  }

  private canSettlementsCommission(): void {
    if (!this.canSettlements && this.riskAnalysisForm.get('commission').value < 0) {
      this.toastrService.success('COMMONS.CALCULATES_INVALID');
    }
  }

  private enableRadioDateNoCampaign(): void {
    this.riskAnalysisForm.get('radioDate').enable();
    this.subscribeToRadioDateChanges();
    this.changeDate();
    this.subscribToCampaignChanges();
    this.subscribeToCalculateCommssionChange();
    if (this.riskAnalysisForm.get('invoiceDate')) {
      this.campaignsSelectDisabled = false;
    }
  }

  private setCupsTensionRepin(data: CupsPTData): void {
    this.tensionSelected = {
      idTension: data.idTension,
      codigoCRM: data.tensionCodigo,
      nombre: data.tensionNombre,
      descripcion: data.tensionDescripcion,
      ciclos: data.ciclos.map(cycle => {
        return {
          idCiclo: cycle.idCiclo,
          codigoCRM: cycle.cicloCodigo,
          nombre: cycle.cicloNombre,
          descripcion: cycle.cicloDescripcion,
          periodos: cycle.periodos.map(period => {
            return {
              idPeriodo: period.idPeriodo,
              codigoCRM: period.periodoCodigo,
              descripcion: period.periodoDescripcion,
              nombre: period.periodoNombre,
              potencias: period.potencias.map(potency => {
                return { valor: potency.potencia };
              })
            };
          })
        };
      })
    };
    this.tensionList = [ { label: this.tensionSelected.descripcion, value: this.tensionSelected.codigoCRM } ];
    this.riskAnalysisForm.get('tension').setValue(this.tensionSelected.codigoCRM);
    this.riskAnalysisForm.get('tension').disable();
    this.setCupsCycleRepin(data);
  }

  private setCupsCycleRepin(data: CupsPTData): void {
    this.cycleList = data.ciclos.map(cycle => {
      return { label: cycle.cicloDescripcion, value: cycle.cicloCodigo };
    });
    if (this.cycleList.length === 1) {
      this.cycleSelected = {
        idCiclo: this.tensionSelected.ciclos[ 0 ].idCiclo,
        codigoCRM: this.tensionSelected.ciclos[ 0 ].codigoCRM,
        nombre: this.tensionSelected.ciclos[ 0 ].nombre,
        descripcion: this.tensionSelected.ciclos[ 0 ].descripcion,
        periodos: this.tensionSelected.ciclos[ 0 ].periodos
      };
      this.riskAnalysisForm.get('cycle').setValue(this.cycleSelected.codigoCRM);
      this.riskAnalysisForm.get('cycle').disable();
    }
    this.setCupsPeriodRepin(data);
  }

  private setCupsPeriodRepin(data: CupsPTData): void {
    if (data.uniquePeriod) {
      this.periodSelected = {
        idPeriodo: this.tensionSelected.ciclos[ 0 ].periodos[ 0 ].idPeriodo,
        codigoCRM: this.tensionSelected.ciclos[ 0 ].periodos[ 0 ].codigoCRM,
        nombre: this.tensionSelected.ciclos[ 0 ].periodos[ 0 ].nombre,
        descripcion: this.tensionSelected.ciclos[ 0 ].periodos[ 0 ].descripcion,
        potencias: this.tensionSelected.ciclos[ 0 ].periodos[ 0 ].potencias
      };
      this.periodList = [ { label: this.periodSelected.descripcion, value: this.periodSelected.codigoCRM } ];
      this.riskAnalysisForm.get('period').setValue(this.periodSelected.codigoCRM);
      this.riskAnalysisForm.get('period').disable();
      this.potencyList = this.periodSelected?.potencias.map(potency => {
        if (potency.valor === 'Otro') {
          return { label: this.i18NextService.t('NEW_CONTRACTS.OTHER_POTENCY'), value: 'Otro' };
        } else {
          return { label: potency.valor, value: potency.valor };
        }
      });
      if (this.potencyList.some(potency => potency.value === 'Otro')) {
        this.minPotency = this.potencyList[ this.potencyList.length - 2 ].value;
      } else {
        this.minPotency = this.potencyList[ this.potencyList.length - 1 ].value;
      }
    } else {
      this.periodList = this.cycleSelected?.periodos?.map(period => {
        return { label: period.descripcion, value: period.codigoCRM }
      });
    }
    this.setCupsPotencyRepin();
  }

  private setCupsPotencyRepin(): void {
    if (this.potencyList.length === 1) {
      this.riskAnalysisForm.get('potency').setValue(this.periodSelected.potencias[ 0 ].valor);
      this.riskAnalysisForm.get('potency').disable();
    }
  }

  private setDraftTensionCyclePeriodPotency(data: AnalysisSavedData) {
    this.tensionSelected = {
      idTension: data.idTension,
      codigoCRM: data.tension,
      descripcion: data.tensionName
    };
    this.tensionList = [ { label: this.tensionSelected.descripcion, value: this.tensionSelected.codigoCRM } ];
    this.cycleSelected = {
      idCiclo: data.idCycle,
      codigoCRM: data.cycle,
      descripcion: data.cycleName
    };
    this.cycleList = [ { label: this.cycleSelected.descripcion, value: this.cycleSelected.codigoCRM } ];
    this.periodSelected = {
      idPeriodo: data.idPeriod,
      codigoCRM: data.period,
      descripcion: data.periodName
    };
    this.periodList = [ { label: this.periodSelected.descripcion, value: this.periodSelected.codigoCRM } ];
    if (data.otraPotencia) {
      this.potencyList = [ { label: this.i18NextService.t('NEW_CONTRACTS.OTHER_POTENCY'), value: 'Otro' } ];
      this.riskAnalysisForm.get('customPotency').setValue(this.riskAnalysisForm.get('potency').value);
      this.riskAnalysisForm.get('potency').setValue('Otro');
    } else {
      this.potencyList = [ { label: this.riskAnalysisForm.get('potency').value, value: this.riskAnalysisForm.get('potency').value } ];
    }
  }

  private resetTensionCyclePeriodPotency(): void {
    this.riskAnalysisForm.get('tension').reset();
    this.riskAnalysisForm.get('cycle').reset();
    this.riskAnalysisForm.get('period').reset();
    this.riskAnalysisForm.get('potency').reset();
    this.riskAnalysisForm.get('customPotency').reset();
    this.riskAnalysisForm.get('consumption').reset();
    this.riskAnalysisForm.get('tension').disable();
    this.riskAnalysisForm.get('cycle').disable();
    this.riskAnalysisForm.get('period').disable();
    this.riskAnalysisForm.get('potency').disable();
    this.riskAnalysisForm.get('consumption').disable();
    this.tensionSelected = null;
    this.cycleSelected = null;
    this.periodSelected = null;
  }

  private enableTensionCyclePeriodPotencyConsumtion(): void {
    if (this.repin && !this.riskAnalysisForm.get('tension').value) {
      this.riskAnalysisForm.get('tension').enable();
      this.riskAnalysisForm.get('tension').updateValueAndValidity();
    } else if (this.repin && !this.riskAnalysisForm.get('cycle').value) {
      this.riskAnalysisForm.get('cycle').enable();
      this.riskAnalysisForm.get('cycle').updateValueAndValidity();
    } else if (this.repin && !this.riskAnalysisForm.get('period').value) {
      this.riskAnalysisForm.get('period').enable();
      this.riskAnalysisForm.get('period').updateValueAndValidity();
    } else if (this.repin && !this.riskAnalysisForm.get('potency').value) {
      this.riskAnalysisForm.get('potency').enable();
      this.riskAnalysisForm.get('potency').updateValueAndValidity();
    } else if (this.repin && !this.riskAnalysisForm.get('consumption').value) {
      this.riskAnalysisForm.get('consumption').enable();
      this.riskAnalysisForm.get('consumption').updateValueAndValidity();
    }
  }

  public getEnterMargins(enterMarginsForm: FormGroup): void {
    this.enterMarginsValid = enterMarginsForm.valid;
    if (this.isUserSpanish) {
      this.riskAnalysisForm.get('enterMargins').setValue({
        marginsTE: {
          p1: enterMarginsForm.get('marginTEP1')?.value?.toString().replace(',', '.') || null,
          p2: enterMarginsForm.get('marginTEP2')?.value?.toString().replace(',', '.') || null,
          p3: enterMarginsForm.get('marginTEP3')?.value?.toString().replace(',', '.') || null,
          p4: enterMarginsForm.get('marginTEP4')?.value?.toString().replace(',', '.') || null,
          p5: enterMarginsForm.get('marginTEP5')?.value?.toString().replace(',', '.') || null,
          p6: enterMarginsForm.get('marginTEP6')?.value?.toString().replace(',', '.') || null,
        },
        marginTP: enterMarginsForm.get('marginTP').value?.toString().replace(',', '.') || null
      });
    } else {
      this.riskAnalysisForm.get('enterMargins').setValue({
        marginsTE: {
          p1: enterMarginsForm.get('marginTEP1')?.value?.toString().replace(',', '.') || null,
          p2: enterMarginsForm.get('marginTEP2')?.value?.toString().replace(',', '.') || null,
          p3: enterMarginsForm.get('marginTEP3')?.value?.toString().replace(',', '.') || null,
          p4: enterMarginsForm.get('marginTEP4')?.value?.toString().replace(',', '.') || null,
          p5: enterMarginsForm.get('marginTEP5')?.value?.toString().replace(',', '.') || null,
          p6: enterMarginsForm.get('marginTEP6')?.value?.toString().replace(',', '.') || null,
        },
      });
    }
    this.riskAnalysisForm.get('enterMargins').updateValueAndValidity();
    this.riskAnalysisForm.get('enterMargins.marginsTE').updateValueAndValidity();
    this.riskAnalysisForm.get('level').setValidators([]);
    this.riskAnalysisForm.get('level').updateValueAndValidity();
    this.resultNegative = false;
    this.formValid.emit({ value: this.riskAnalysisForm.valid && this.enterMarginsValid, tab: 0 });
  }

  private subscribePaymentChanges(): void {
    this.riskAnalysisForm.get('payment').valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(value => {
      if (value === '1') {
        ['iban', 'entity', 'office', 'account', 'dc'].forEach(field => {
          this.riskAnalysisForm.get(field).reset();
        });
      }
      this.showBankAccount(value === '0' && this.riskAnalysisForm.get('campaign')?.value);
      if (!this.newContractPymesService.getSavedData().value.savedDataFromDraft) {
        this.savePayment(this.riskAnalysisForm.get('invoiceDate').value);
      }
      this.cdRef.detectChanges();
    });
    if (!this.newContractPymesService.getSavedData().value.savedDataFromDraft) {
      ['iban', 'entity', 'office', 'account', 'dc'].forEach(field => {
        this.riskAnalysisForm.get(field).valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(value => {
          this.savePayment(this.riskAnalysisForm.get('invoiceDate').value);
        });
      });
    }
  }

  private enablePayment(enable: boolean): void {
    enable ? this.riskAnalysisForm.get('payment').enable() : this.riskAnalysisForm.get('payment').disable();
  }

  private showBankAccount(show: boolean): void {
    this.showBankAccountFields = show;
    const enableBankAccount = this.riskAnalysisForm.get('payment').value === '0';
    enableBankAccount ? this.riskAnalysisForm.get('iban').enable() : this.riskAnalysisForm.get('iban').disable();
    enableBankAccount ? this.riskAnalysisForm.get('entity').enable() : this.riskAnalysisForm.get('entity').disable();
    enableBankAccount ? this.riskAnalysisForm.get('office').enable() : this.riskAnalysisForm.get('office').disable();
    enableBankAccount ? this.riskAnalysisForm.get('account').enable() : this.riskAnalysisForm.get('account').disable();
    enableBankAccount ? this.riskAnalysisForm.get('dc').enable() : this.riskAnalysisForm.get('dc').disable();
    if (show) {
      this.riskAnalysisForm.get('iban').setValidators(Validators.required);
      this.riskAnalysisForm.get('entity').setValidators(Validators.required);
      this.riskAnalysisForm.get('office').setValidators(Validators.required);
      this.riskAnalysisForm.get('account').setValidators(Validators.required);
      this.riskAnalysisForm.get('dc').setValidators(Validators.required);
      this.riskAnalysisForm.setValidators(this.validateIBANControlsPT);
    } else {
      this.riskAnalysisForm.get('iban').removeValidators(Validators.required);
      this.riskAnalysisForm.get('entity').removeValidators(Validators.required);
      this.riskAnalysisForm.get('office').removeValidators(Validators.required);
      this.riskAnalysisForm.get('account').removeValidators(Validators.required);
      this.riskAnalysisForm.get('dc').removeValidators(Validators.required);
      this.riskAnalysisForm.removeValidators(this.validateIBANControlsPT);
    }
    this.riskAnalysisForm.get('iban').updateValueAndValidity();
    this.riskAnalysisForm.get('entity').updateValueAndValidity();
    this.riskAnalysisForm.get('office').updateValueAndValidity();
    this.riskAnalysisForm.get('account').updateValueAndValidity();
    this.riskAnalysisForm.get('dc').updateValueAndValidity();
    this.riskAnalysisForm.updateValueAndValidity();
  }

  public onPasteIBAN(event: ClipboardEvent): void {
    const pasteIBAN: string = event.clipboardData.getData('text').replace(/\s/g, '');
    if (pasteIBAN.length === 25) {
      this.riskAnalysisForm.patchValue({
        iban: pasteIBAN.slice(0, 4),
        entity: pasteIBAN.slice(4, 8),
        office: pasteIBAN.slice(8, 12),
        account: pasteIBAN.slice(12, 23),
        dc: pasteIBAN.slice(23, 25)
      });
    }
  }

  public bankAccountKeyUp(
    event: KeyboardEvent,
    previousInputId: string | null,
    currentInputId: string,
    nextInputId: string | null
  ): void {
    const previousInput = this.getInputElement(previousInputId);
    const currentInput = this.getInputElement(currentInputId);
    const nextInput = this.getInputElement(nextInputId);
    currentInput.value = currentInput.value.replace(' ', '');
    if (!event.ctrlKey && event.key !== 'Control') {
      if (currentInput.selectionStart === currentInput.maxLength && nextInput) {
        nextInput.focus();
        nextInput.setSelectionRange(0, 0);
      } else if (
        (event.key === 'Backspace' || event.key === 'ArrowLeft')
        && currentInput.selectionStart === 0
        && previousInput
      ) {
        previousInput.focus();
      }
    }
  }

  private getInputElement(id: string): HTMLInputElement | null {
    return id ? (document.getElementById(id) as HTMLInputElement) : null;
  }

  private validateIBANControlsPT(control: AbstractControl): ValidationErrors | null {
    const iban = control.get('iban').value ?? '';
    const entity = control.get('entity').value ?? '';
    const office = control.get('office').value ?? '';
    const dc = control.get('dc').value ?? '';
    const account = control.get('account').value ?? '';
    const accountEmpty = iban === '' && account === '' && entity === '' && office === '' && dc === '';
    if (!accountEmpty && !validateIBANPortugal(entity, office, dc, account)) {
      return { invalid_IBAN: true };
    }
    return null;
  }

  public checkControlRequired(controlName: string): boolean {
    return this.riskAnalysisForm.get(controlName)?.errors?.required &&
      (this.riskAnalysisForm.get(controlName)?.touched || this.riskAnalysisForm.get(controlName)?.dirty) && ! this.checkControlIban();
  }

  public checkControlIban(): boolean {
    const keysObject = Object.keys(this.riskAnalysisForm.controls).filter(val => val.startsWith('iban'));
    const haveValues = keysObject.some(key => !!this.riskAnalysisForm.get(key).value);
    const touchedOrDirty = keysObject.some(key => this.riskAnalysisForm.get(key).touched || this.riskAnalysisForm.get(key).dirty);
    return haveValues && this.riskAnalysisForm.hasError('invalid_IBAN') && touchedOrDirty;
  }
}
